// IATA Airport Codes — 1952 airports worldwide
// Curated names from latest official list, supplemented by comprehensive database
export const AIRPORTS = {
  "AAC": { name: "Al Arish", city: "Al Arish", country: "Egypt" },
  "AAE": { name: "Annaba", city: "Annaba", country: "Algeria" },
  "AAL": { name: "Alborg", city: "Alborg", country: "Denmark" },
  "AAN": { name: "Al Ain", city: "Al Ain", country: "United Arab Emirates" },
  "AAR": { name: "Aarhus", city: "Aarhus", country: "Denmark" },
  "AAT": { name: "Altay", city: "Altay", country: "PR China" },
  "ABD": { name: "Abadan", city: "Abadan", country: "Iran" },
  "ABE": { name: "Allentown", city: "Allentown", country: "USA" },
  "ABI": { name: "Abilene", city: "Abilene", country: "USA" },
  "ABJ": { name: "Abidjan", city: "Abidjan", country: "Cote d'Ivoire" },
  "ABM": { name: "Bamaga", city: "Bamaga", country: "Australia" },
  "ABQ": { name: "Albuquerque (NM)", city: "Albuquerque", country: "USA" },
  "ABR": { name: "Aberdeen", city: "Aberdeen", country: "USA" },
  "ABS": { name: "Abu Simbel", city: "Abu Simbel", country: "Egypt" },
  "ABV": { name: "Nnamdi Azikiwe International Airport", city: "Abuja", country: "Nigeria" },
  "ABX": { name: "Albury", city: "Albury", country: "Australia" },
  "ABY": { name: "Albany", city: "Albany", country: "USA" },
  "ABZ": { name: "Aberdeen", city: "Aberdeen", country: "United Kingdom" },
  "ACA": { name: "Acapulco", city: "Acapulco", country: "Mexico" },
  "ACC": { name: "Kotoka International Airport", city: "Accra", country: "Ghana" },
  "ACE": { name: "Arrecife/Lanzarote", city: "Arrecife/Lanzarote", country: "Spain" },
  "ACH": { name: "Altenrhein", city: "Altenrhein", country: "Switzerland" },
  "ACI": { name: "Alderney", city: "Alderney", country: "Channel Islands" },
  "ACK": { name: "Nantucket", city: "Nantucket", country: "USA" },
  "ACT": { name: "Waco", city: "Waco", country: "USA" },
  "ACV": { name: "Eureka", city: "Eureka", country: "USA" },
  "ACY": { name: "Atlantic City International", city: "Atlantic City", country: "USA" },
  "ADA": { name: "Adana", city: "Adana", country: "Turkey" },
  "ADB": { name: "Adnan Menderes Airport", city: "Izmir", country: "Turkey" },
  "ADD": { name: "Bole International Airport", city: "Addis Ababa", country: "Ethiopia" },
  "ADE": { name: "Aden International Airport", city: "Aden", country: "Yemen" },
  "ADF": { name: "Adiyaman", city: "Adiyaman", country: "Turkey" },
  "ADJ": { name: "Amman-Marka International Airport", city: "Amman", country: "Jordan" },
  "ADL": { name: "Adelaide", city: "Adelaide", country: "Australia" },
  "ADQ": { name: "Kodiak", city: "Kodiak", country: "USA" },
  "ADY": { name: "Alldays", city: "Alldays", country: "South Africa" },
  "ADZ": { name: "San Andres", city: "San Andres", country: "Colombia" },
  "AEH": { name: "Abeche", city: "Abeche", country: "Chad" },
  "AEP": { name: "Buenos Aires, Jorge Newbery", city: "Buenos Aires, Jorge Newbery", country: "Argentina" },
  "AER": { name: "Adler/Sochi", city: "Adler/Sochi", country: "Russia" },
  "AES": { name: "Alesund", city: "Alesund", country: "Norway" },
  "AGA": { name: "Agadir", city: "Agadir", country: "Morocco" },
  "AGB": { name: "Augsbur gAirport", city: "Augsburg", country: "Germany" },
  "AGP": { name: "Malaga", city: "Malaga", country: "Spain" },
  "AGS": { name: "Augusta", city: "Augusta", country: "USA" },
  "AGU": { name: "Aguascaliente", city: "Aguascaliente", country: "Mexico" },
  "AGZ": { name: "Aggeneys", city: "Aggeneys", country: "South Africa" },
  "AHB": { name: "Khamis Mushayat", city: "Khamis Mushayat", country: "Saudi Arabia" },
  "AHN": { name: "Athens", city: "Athens", country: "USA" },
  "AHO": { name: "Alghero Sassari", city: "Alghero Sassari", country: "Italy" },
  "AHU": { name: "Al Hoceima", city: "Al Hoceima", country: "Morocco" },
  "AJA": { name: "Ajaccio", city: "Ajaccio", country: "France" },
  "AJF": { name: "Jouf", city: "Jouf", country: "Saudi Arabia" },
  "AJN": { name: "Anjouan Airport", city: "Anjouan", country: "Comoros (Comores)" },
  "AJU": { name: "Aracaju", city: "Aracaju", country: "Brazil" },
  "AJY": { name: "Agades", city: "Agades", country: "Niger" },
  "AKL": { name: "Auckland International Airport", city: "Auckland", country: "New Zealand" },
  "AKN": { name: "King Salomon", city: "King Salomon", country: "USA" },
  "AKT": { name: "RAF", city: "Akrotiri", country: "Cyprus" },
  "ALA": { name: "Almaty International Airport", city: "Almaty", country: "Kazakhstan" },
  "ALB": { name: "Albany International Airport", city: "Albany", country: "USA" },
  "ALC": { name: "Alicante", city: "Alicante", country: "Spain" },
  "ALF": { name: "Alta", city: "Alta", country: "Norway" },
  "ALG": { name: "Houari Boumediene Airport", city: "Algiers", country: "Algeria" },
  "ALH": { name: "Albany", city: "Albany", country: "Australia" },
  "ALJ": { name: "Kortdoorn", city: "Alexander Bay", country: "South Africa" },
  "ALO": { name: "Waterloo IA", city: "Waterloo IA", country: "USA" },
  "ALP": { name: "Aleppo", city: "Aleppo", country: "Syria" },
  "ALV": { name: "Heliport", city: "Andorra La Vella", country: "Andorra" },
  "ALW": { name: "Walla Walla", city: "Walla Walla", country: "USA" },
  "ALY": { name: "El Nhouza Airport", city: "Alexandria", country: "Egypt" },
  "AMA": { name: "Amarillo", city: "Amarillo", country: "USA" },
  "AMD": { name: "Ahmedabad", city: "Ahmedabad", country: "India" },
  "AMM": { name: "Queen Alia International Airport", city: "Amman", country: "Jordan" },
  "AMS": { name: "Amsterdam Airport Schiphol", city: "Amsterdam", country: "Netherlands" },
  "ANB": { name: "Anniston", city: "Anniston", country: "USA" },
  "ANC": { name: "Ted Stevens Anchorage International", city: "Anchorage", country: "USA" },
  "ANK": { name: "Ankara", city: "Ankara", country: "Turkey" },
  "ANR": { name: "Antwerp", city: "Antwerp", country: "Belgium" },
  "ANU": { name: "V.C. Bird International", city: "Antigua", country: "Antigua and Barbuda" },
  "AOI": { name: "Ancona Falconara Airport", city: "Ancona", country: "Italy" },
  "AOJ": { name: "Aomori", city: "Aomori", country: "Japan" },
  "AOK": { name: "Karpathos", city: "Karpathos", country: "Greece" },
  "AOO": { name: "Altoona", city: "Altoona", country: "USA" },
  "APF": { name: "Naples", city: "Naples", country: "USA" },
  "APW": { name: "Faleolo International Airport", city: "Apia", country: "Samoa" },
  "AQJ": { name: "Aqaba", city: "Aqaba", country: "Jordan" },
  "ARB": { name: "Ann Arbor", city: "Ann Arbor", country: "USA" },
  "ARH": { name: "Arkhangelsk", city: "Arkhangelsk", country: "Russia" },
  "ARK": { name: "Arusha", city: "Arusha", country: "Tanzania" },
  "ARN": { name: "Arlanda Airport", city: "Stockholm", country: "Sweden" },
  "ASB": { name: "Saparmurat Turkmenbashy Int. Airport", city: "Ashgabat", country: "Turkmenistan" },
  "ASE": { name: "Aspen-Pitkin County Airport", city: "Aspen,", country: "USA" },
  "ASJ": { name: "Amami", city: "Amami", country: "Japan" },
  "ASK": { name: "Yamoussoukro", city: "Yamoussoukro", country: "Côte d'Ivoire" },
  "ASM": { name: "Asmara International", city: "Asmara", country: "Eritrea" },
  "ASP": { name: "Alice Springs", city: "Alice Springs", country: "Australia" },
  "ASR": { name: "Kayseri", city: "Kayseri", country: "Turkey" },
  "ASU": { name: "Asunción International Airport", city: "Asuncion", country: "Paraguay" },
  "ASW": { name: "Daraw Airport", city: "Aswan", country: "Egypt" },
  "ATH": { name: "Elefthérios Venizélos International Airport", city: "Athens", country: "Greece" },
  "ATL": { name: "Hartsfield–Jackson Atlanta International Airport", city: "Atlanta", country: "USA" },
  "ATO": { name: "Athens", city: "Athens", country: "USA" },
  "ATQ": { name: "Amritsar", city: "Amritsar", country: "India" },
  "ATW": { name: "Appelton/Neenah/Menasha", city: "Appelton/Neenah/Menasha", country: "USA" },
  "ATY": { name: "Watertown", city: "Watertown", country: "USA" },
  "ATZ": { name: "Assiut", city: "Assiut", country: "Egypt" },
  "AUA": { name: "Reina Beatrix International", city: "Aruba", country: "Aruba" },
  "AUE": { name: "Abu Rudeis", city: "Abu Rudeis", country: "Egypt" },
  "AUG": { name: "Augusta State Airport", city: "Augusta", country: "USA" },
  "AUH": { name: "Zayed International Airport", city: "Abu Dhabi", country: "United Arab Emirates" },
  "AUR": { name: "Aurillac", city: "Aurillac", country: "France" },
  "AUS": { name: "Austin-Bergstrom Airport", city: "Austin", country: "USA" },
  "AVL": { name: "Asheville", city: "Asheville", country: "USA" },
  "AVP": { name: "Wilkes Barre/Scranton", city: "Wilkes Barre/Scranton", country: "USA" },
  "AXA": { name: "Anguilla", city: "Anguilla", country: "Anguilla" },
  "AXS": { name: "Altus", city: "Altus", country: "USA" },
  "AXT": { name: "Akita", city: "Akita", country: "Japan" },
  "AYQ": { name: "Connellan", city: "Ayers Rock", country: "Australia" },
  "AYR": { name: "Ayr", city: "Ayr", country: "Australia" },
  "AYT": { name: "Antalya", city: "Antalya", country: "Turkey" },
  "AYU": { name: "Aiyura", city: "Aiyura", country: "Papua New Guinea" },
  "AYW": { name: "Ayawasi", city: "Ayawasi", country: "Indonesia" },
  "AZB": { name: "Amazon Bay", city: "Amazon Bay", country: "Papua New Guinea" },
  "AZO": { name: "Kalamazoo/Battle Creek", city: "Kalamazoo/Battle Creek", country: "USA" },
  "AZP": { name: "Atizapan", city: "Mexico City", country: "Mexico" },
  "AZS": { name: "Samaná El Catey International Airport", city: "Samana", country: "Dominican Republic" },
  "BAH": { name: "Bahrain International Airport", city: "Bahrain", country: "Bahrain" },
  "BAQ": { name: "Barranquilla", city: "Barranquilla", country: "Colombia" },
  "BBI": { name: "Bhubaneswar", city: "Bhubaneswar", country: "India" },
  "BBT": { name: "Berberati", city: "Berberati", country: "Central African Republic" },
  "BBY": { name: "Bambari", city: "Bambari", country: "Central African Republic" },
  "BCN": { name: "Barcelona", city: "Barcelona", country: "Spain" },
  "BCO": { name: "Baco/Jinka Airport", city: "Jinka", country: "Ethiopia" },
  "BDA": { name: "L.F. Wade International Airport", city: "Bermuda", country: "Bermuda" },
  "BDB": { name: "Bundaberg", city: "Bundaberg", country: "Australia" },
  "BDL": { name: "Bradley International Airport", city: "Hartford", country: "USA" },
  "BDO": { name: "Husein Sastranegara International Airport", city: "Bandung", country: "Indonesia" },
  "BDQ": { name: "Baroda", city: "Baroda", country: "India" },
  "BDR": { name: "Bridgeport", city: "Bridgeport", country: "USA" },
  "BDS": { name: "Brindisi", city: "Brindisi", country: "Italy" },
  "BDU": { name: "Bardufoss", city: "Bardufoss", country: "Norway" },
  "BEB": { name: "Benbecula", city: "Benbecula", country: "United Kingdom" },
  "BEG": { name: "Belgrade Nikola Tesla International", city: "Belgrade", country: "Serbia" },
  "BEH": { name: "Benton Harbour", city: "Benton Harbour", country: "USA" },
  "BEL": { name: "Val de Cans International Airport", city: "Belem", country: "Brazil" },
  "BEN": { name: "Benghazi", city: "Benghazi", country: "Libya" },
  "BEO": { name: "Belmont", city: "Newcastle", country: "Australia" },
  "BER": { name: "Berlin Brandenburg Airport Willy Brandt", city: "Berlin", country: "Germany" },
  "BES": { name: "Brest", city: "Brest", country: "France" },
  "BET": { name: "Bethel", city: "Bethel", country: "USA" },
  "BEW": { name: "Beira", city: "Beira", country: "Mozambique" },
  "BEY": { name: "Beirut Rafic Hariri International Airport", city: "Beirut", country: "Lebanon" },
  "BFD": { name: "Bradford/Warren (PA) /Olean", city: "Bradford/Warren (PA) /Olean", country: "USA" },
  "BFL": { name: "Bakersfield", city: "Bakersfield", country: "USA" },
  "BFN": { name: "Bloemfontein Airport", city: "Bloemfontein", country: "South Africa" },
  "BFO": { name: "Buffalo Range", city: "Buffalo Range", country: "Zimbabwe" },
  "BFS": { name: "Belfast International Airport", city: "Belfast", country: "United Kingdom" },
  "BGA": { name: "Bucaramanga", city: "Bucaramanga", country: "Colombia" },
  "BGF": { name: "M'Poko International Airport", city: "Bangui", country: "Central African Republic" },
  "BGI": { name: "Grantley Adams International", city: "Bridgetown", country: "Barbados" },
  "BGM": { name: "Binghamton/Endicott/Johnson", city: "Johnson City", country: "USA" },
  "BGO": { name: "Bergen", city: "Bergen", country: "Norway" },
  "BGR": { name: "Bangor", city: "Bangor", country: "USA" },
  "BGU": { name: "Bangassou", city: "Bangassou", country: "Central African Republic" },
  "BGW": { name: "Baghdad International Airport", city: "Baghdad", country: "Iraq" },
  "BGY": { name: "Orio Al Serio", city: "Milan", country: "Italy" },
  "BHC": { name: "Bullhead City", city: "Bullhead City", country: "USA" },
  "BHD": { name: "George Best Belfast City Airport", city: "Belfast", country: "United Kingdom" },
  "BHE": { name: "Blenheim", city: "Blenheim", country: "New Zealand" },
  "BHM": { name: "Birmingham", city: "Birmingham", country: "USA" },
  "BHO": { name: "Bhopal", city: "Bhopal", country: "India" },
  "BHQ": { name: "Broken Hill", city: "Broken Hill", country: "Australia" },
  "BHV": { name: "Bahawalpur", city: "Bahawalpur", country: "Pakistan" },
  "BHX": { name: "Birmingham", city: "Birmingham", country: "United Kingdom" },
  "BIA": { name: "Bastia", city: "Bastia", country: "France" },
  "BIL": { name: "Billings", city: "Billings", country: "USA" },
  "BIO": { name: "Bilbao", city: "Bilbao", country: "Spain" },
  "BIQ": { name: "Biarritz", city: "Biarritz", country: "France" },
  "BIS": { name: "Bismarck Municipal Airport", city: "Bismarck", country: "USA" },
  "BIV": { name: "Bria", city: "Bria", country: "Central African Republic" },
  "BJI": { name: "Bemidji", city: "Bemidji", country: "USA" },
  "BJL": { name: "Banjul International Airport", city: "Banjul", country: "Gambia" },
  "BJM": { name: "Bujumbura International Airport", city: "Bujumbura", country: "Burundi" },
  "BJV": { name: "Milas Airport", city: "Bodrum", country: "Turkey" },
  "BJX": { name: "Leon", city: "Leon", country: "Mexico" },
  "BJZ": { name: "Badajoz", city: "Badajoz", country: "Spain" },
  "BKI": { name: "Kota Kinabalu", city: "Kota Kinabalu", country: "Malaysia" },
  "BKK": { name: "Suvarnabhumi International", city: "Bangkok", country: "Thailand" },
  "BKL": { name: "Cleveland (OH) , Burke Lakefront", city: "Cleveland (OH) , Burke Lakefront", country: "USA" },
  "BKO": { name: "Bamako-Sénou International Airport", city: "Bamako", country: "Mali" },
  "BKW": { name: "Beckley", city: "Beckley", country: "USA" },
  "BKX": { name: "Brookings", city: "Brookings", country: "USA" },
  "BLA": { name: "Barcelona", city: "Barcelona", country: "Venezuela" },
  "BLF": { name: "Bluefield", city: "Bluefield", country: "USA" },
  "BLI": { name: "Bellingham", city: "Bellingham", country: "USA" },
  "BLK": { name: "Blackpool", city: "Blackpool", country: "United Kingdom" },
  "BLL": { name: "Billund", city: "Billund", country: "Denmark" },
  "BLQ": { name: "Bologna", city: "Bologna", country: "Italy" },
  "BLR": { name: "Kempegowda International Airport", city: "Bangalore", country: "India" },
  "BLT": { name: "Blackwater", city: "Blackwater", country: "Australia" },
  "BLZ": { name: "Chileka International Airport", city: "Blantyre", country: "Malawi" },
  "BMA": { name: "Bromma", city: "Stockholm", country: "Sweden" },
  "BME": { name: "Broome", city: "Broome", country: "Australia" },
  "BMG": { name: "Bloomington", city: "Bloomington", country: "USA" },
  "BMI": { name: "Bloomington", city: "Bloomington", country: "USA" },
  "BMP": { name: "Brampton Island", city: "Brampton Island", country: "Australia" },
  "BNA": { name: "Nashville", city: "Nashville", country: "USA" },
  "BNE": { name: "Brisbane", city: "Brisbane", country: "Australia" },
  "BNK": { name: "Ballina", city: "Ballina", country: "Australia" },
  "BNN": { name: "Broennoeysund", city: "Broennoeysund", country: "Norway" },
  "BNP": { name: "Bannu", city: "Bannu", country: "Pakistan" },
  "BOB": { name: "Bora Bora", city: "Bora Bora", country: "French Polynesia" },
  "BOD": { name: "Bordeaux", city: "Bordeaux", country: "France" },
  "BOG": { name: "El Dorado International Airport", city: "Bogota", country: "Colombia" },
  "BOH": { name: "Bournemouth", city: "Bournemouth", country: "United Kingdom" },
  "BOI": { name: "Boise Air Terminal", city: "Boise", country: "USA" },
  "BOJ": { name: "Bourgas/Burgas", city: "Bourgas/Burgas", country: "Bulgaria" },
  "BOM": { name: "Chhatrapati Shivaji Maharaj International", city: "Mumbai", country: "India" },
  "BON": { name: "Bonaire", city: "Bonaire", country: "Netherlands" },
  "BOO": { name: "Bodo", city: "Bodo", country: "Norway" },
  "BOS": { name: "Logan International Airport", city: "Boston", country: "USA" },
  "BOY": { name: "Bobo/Dioulasso", city: "Bobo/Dioulasso", country: "Burkina Faso" },
  "BPT": { name: "Beaumont/Pt. Arthur", city: "Beaumont/Pt. Arthur", country: "USA" },
  "BQK": { name: "Brunswick", city: "Brunswick", country: "USA" },
  "BQN": { name: "Aguadilla", city: "Aguadilla", country: "Puerto Rico" },
  "BRC": { name: "San Carlos de Bariloche", city: "San Carlos de Bariloche", country: "Argentina" },
  "BRD": { name: "Brainerd", city: "Brainerd", country: "USA" },
  "BRE": { name: "Bremen", city: "Bremen", country: "Germany" },
  "BRI": { name: "Bari", city: "Bari", country: "Italy" },
  "BRL": { name: "Burlington IA", city: "Burlington IA", country: "USA" },
  "BRN": { name: "Berne, Bern-Belp", city: "Berne, Bern-Belp", country: "Switzerland" },
  "BRR": { name: "Barra", city: "Barra", country: "United Kingdom" },
  "BRS": { name: "Bristol", city: "Bristol", country: "United Kingdom" },
  "BRU": { name: "Brussels Airport", city: "Brussels", country: "Belgium" },
  "BSB": { name: "President Juscelino Kubitschek International", city: "Brasilia", country: "Brazil" },
  "BSL": { name: "Basel", city: "Basel", country: "Switzerland" },
  "BSR": { name: "Basra, Basrah", city: "Basra, Basrah", country: "Iraq" },
  "BTM": { name: "Butte", city: "Butte", country: "USA" },
  "BTR": { name: "Baton Rouge Metropolitan Airport", city: "Baton Rouge", country: "USA" },
  "BTS": { name: "M. R. Štefánik Airport", city: "Bratislava", country: "Slovakia" },
  "BTU": { name: "Bintulu", city: "Bintulu", country: "Malaysia" },
  "BTV": { name: "Burlington", city: "Burlington", country: "USA" },
  "BUD": { name: "Budapest Ferenc Liszt International Airport", city: "Budapest", country: "Hungary" },
  "BUE": { name: "Buenos Aires", city: "Buenos Aires", country: "Argentina" },
  "BUF": { name: "Buffalo/Niagara Falls", city: "Buffalo/Niagara Falls", country: "USA" },
  "BUG": { name: "Benguela", city: "Benguela", country: "Angola" },
  "BUH": { name: "Bucharest", city: "Bucharest", country: "Romania" },
  "BUQ": { name: "Bulawayo", city: "Bulawayo", country: "Zimbabwe" },
  "BUR": { name: "Burbank", city: "Burbank", country: "USA" },
  "BVB": { name: "Boa Vista", city: "Boa Vista", country: "Brazil" },
  "BWI": { name: "Washington International Airport", city: "Baltimore", country: "USA" },
  "BWN": { name: "Brunei International Airport", city: "Bandar Seri Begawan", country: "Brunei" },
  "BWT": { name: "Burnie", city: "Burnie", country: "Australia" },
  "BXS": { name: "Borrego Springs", city: "Borrego Springs", country: "USA" },
  "BYK": { name: "Bouake", city: "Bouake", country: "Cote d'Ivoire" },
  "BYU": { name: "Bindlacher-Berg", city: "Bayreuth", country: "Germany" },
  "BZE": { name: "Philip S.W. Goldson International", city: "Belize City", country: "Belize" },
  "BZL": { name: "Barisal", city: "Barisal", country: "Bangladesh" },
  "BZN": { name: "Bozeman", city: "Bozeman", country: "USA" },
  "BZV": { name: "Maya-Maya Airport", city: "Brazzaville", country: "Congo (ROC)" },
  "CAB": { name: "Cabinda", city: "Cabinda", country: "Angola" },
  "CAE": { name: "Columbia Metropolitan Airport", city: "Columbia", country: "USA" },
  "CAG": { name: "Cagliari", city: "Cagliari", country: "Italy" },
  "CAI": { name: "Cairo International Airport", city: "Cairo", country: "Egypt" },
  "CAK": { name: "Akron", city: "Akron", country: "USA" },
  "CAL": { name: "Campbeltown", city: "Campbeltown", country: "United Kingdom" },
  "CAN": { name: "Baiyun International Airport", city: "Guangzhou", country: "China" },
  "CAS": { name: "Casablanca", city: "Casablanca", country: "Morocco" },
  "CAY": { name: "Cayenne-Rochambeau Airport", city: "Cayenne", country: "French Guiana" },
  "CBB": { name: "Cochabamba", city: "Cochabamba", country: "Bolivia" },
  "CBG": { name: "Cambrigde", city: "Cambrigde", country: "United Kingdom" },
  "CBR": { name: "Canberra", city: "Canberra", country: "Australia" },
  "CBU": { name: "Cottbus-Drewitz Airport", city: "Cottbus", country: "Germany" },
  "CCJ": { name: "Calicut", city: "Calicut", country: "India" },
  "CCR": { name: "Buchanan Field", city: "Concord", country: "USA" },
  "CCS": { name: "Simón Bolívar International Airport", city: "Caracas", country: "Venezuela" },
  "CCU": { name: "Netaji Subhas Chandra", city: "Kolkata", country: "India" },
  "CCZ": { name: "Chub Cay", city: "Chub Cay", country: "Bahamas" },
  "CDC": { name: "Cedar City", city: "Cedar City", country: "USA" },
  "CDG": { name: "Charles de Gaulle Airport", city: "Paris", country: "France" },
  "CDV": { name: "Cordova", city: "Cordova", country: "USA" },
  "CEB": { name: "Mactan–Cebu International Airport", city: "Cebu", country: "Philippines" },
  "CEC": { name: "Crescent City", city: "Crescent City", country: "USA" },
  "CED": { name: "Ceduna", city: "Ceduna", country: "Australia" },
  "CEN": { name: "Ciudad Obregon", city: "Ciudad Obregon", country: "Mexico" },
  "CEQ": { name: "Cannes – Mandelieu Airport", city: "Cannes – Mandelieu Airport", country: "France" },
  "CES": { name: "Cessnock", city: "Cessnock", country: "Australia" },
  "CFE": { name: "Clermont Ferrand", city: "Clermont Ferrand", country: "France" },
  "CFG": { name: "Jaime González Airport", city: "Cienfuegos", country: "Cuba" },
  "CFN": { name: "Donegal", city: "Donegal", country: "Ireland" },
  "CFS": { name: "Coffs Harbour", city: "Coffs Harbour", country: "Australia" },
  "CFU": { name: "Corfu", city: "Corfu", country: "Greece" },
  "CGA": { name: "Craig", city: "Craig", country: "USA" },
  "CGB": { name: "Marechal Rondon International Airport", city: "Cuiaba", country: "Brazil" },
  "CGH": { name: "Congonhas", city: "Sao Paulo", country: "Brazil" },
  "CGK": { name: "Soekarno–Hatta International Airport", city: "Jakarta", country: "Indonesia" },
  "CGN": { name: "Cologne/Bonn", city: "Cologne/Bonn", country: "Germany" },
  "CGP": { name: "Chittagong", city: "Chittagong", country: "Bangladesh" },
  "CGQ": { name: "Changchun", city: "Changchun", country: "Jilin, PR China" },
  "CGR": { name: "Campo Grande", city: "Campo Grande", country: "Brazil" },
  "CGU": { name: "Ciudad Guayana", city: "Ciudad Guayana", country: "Venezuela" },
  "CHA": { name: "Chattanooga", city: "Chattanooga", country: "USA" },
  "CHC": { name: "Christchurch", city: "Christchurch", country: "New Zealand" },
  "CHG": { name: "Chaoyang Airport", city: "Chaoyang, Beijing", country: "PR China" },
  "CHI": { name: "Chicago", city: "Chicago", country: "USA" },
  "CHO": { name: "Charlottesville", city: "Charlottesville", country: "USA" },
  "CHQ": { name: "Chania", city: "Chania", country: "Greece" },
  "CHS": { name: "Charleston", city: "Charleston", country: "USA" },
  "CIA": { name: "Ciampino", city: "Rome", country: "Italy" },
  "CIC": { name: "Chico", city: "Chico", country: "USA" },
  "CID": { name: "Cedar Rapids IA", city: "Cedar Rapids IA", country: "USA" },
  "CIP": { name: "Chipata", city: "Chipata", country: "Zambia" },
  "CIW": { name: "Canouan Airport", city: "Canouan", country: "Saint Vincent & the Grenadines" },
  "CJB": { name: "Coimbatore", city: "Coimbatore", country: "India" },
  "CJC": { name: "El Loa", city: "Calama", country: "Chile" },
  "CJL": { name: "Chitral", city: "Chitral", country: "Pakistan" },
  "CJS": { name: "Ciudad Juarez", city: "Ciudad Juarez", country: "Mexico" },
  "CKB": { name: "Clarksburg", city: "Clarksburg", country: "USA" },
  "CKG": { name: "Jiangbei International Airport", city: "Chongqing", country: "China" },
  "CKY": { name: "Conakry International Airport", city: "Conakry", country: "Guinea" },
  "CLD": { name: "Carlsbad", city: "Carlsbad", country: "USA" },
  "CLE": { name: "Cleveland Hopkins International", city: "Cleveland", country: "USA" },
  "CLL": { name: "College Station/Bryan", city: "College Station/Bryan", country: "USA" },
  "CLM": { name: "Port Angeles", city: "Port Angeles", country: "USA" },
  "CLO": { name: "Alfonso Bonilla Aragón International Airport", city: "Cali", country: "Colombia" },
  "CLQ": { name: "Colima", city: "Colima", country: "Mexico" },
  "CLT": { name: "Charlotte Douglas International Airport", city: "Charlotte", country: "USA" },
  "CLY": { name: "Calvi", city: "Calvi", country: "France" },
  "CMB": { name: "Bandaranaike International Airport", city: "Colombo", country: "Sri Lanka" },
  "CME": { name: "Ciudad Del Carmen", city: "Ciudad Del Carmen", country: "Mexico" },
  "CMF": { name: "Chambery", city: "Chambery", country: "France" },
  "CMH": { name: "Port Columbus International", city: "Columbus", country: "USA" },
  "CMI": { name: "Champaign", city: "Champaign", country: "USA" },
  "CMN": { name: "Mohammed V International Airport", city: "Casablanca", country: "Morocco" },
  "CMQ": { name: "Clermont", city: "Clermont", country: "Australia" },
  "CMX": { name: "Hancock", city: "Hancock", country: "USA" },
  "CND": { name: "Constanta Int'l Airport", city: "Constanta", country: "Romania" },
  "CNF": { name: "Tancredo Neves International Airport", city: "Belo Horizonte", country: "Brazil" },
  "CNS": { name: "Cairns", city: "Cairns", country: "Australia" },
  "CNX": { name: "Chiang Mai International Airport", city: "Chiang Mai", country: "Thailand" },
  "COD": { name: "Cody/Powell/Yellowstone", city: "Cody/Powell/Yellowstone", country: "USA" },
  "COK": { name: "Cochin", city: "Cochin", country: "India" },
  "CON": { name: "Concord Municipal Airport", city: "Concord", country: "USA" },
  "COO": { name: "Cotonou Cadjehoun Airport", city: "Cotonou", country: "Benin" },
  "COR": { name: "Cordoba", city: "Cordoba", country: "Argentina" },
  "COS": { name: "Colorado Springs", city: "Colorado Springs", country: "USA" },
  "CPD": { name: "Coober Pedy", city: "Coober Pedy", country: "Australia" },
  "CPH": { name: "Copenhagen", city: "Copenhagen", country: "Denmark" },
  "CPR": { name: "Casper", city: "Casper", country: "USA" },
  "CPT": { name: "Cape Town International Airport", city: "Cape Town", country: "South Africa" },
  "CRE": { name: "Grand Strand Airport", city: "Myrtle Beach", country: "USA" },
  "CRF": { name: "Carnot", city: "Carnot", country: "Central African Republic" },
  "CRG": { name: "Craig Municipal", city: "Jacksonville", country: "USA" },
  "CRP": { name: "Corpus Christi", city: "Corpus Christi", country: "USA" },
  "CRW": { name: "Yeager Airport", city: "Charleston", country: "USA" },
  "CSG": { name: "Columbus", city: "Columbus", country: "USA" },
  "CSI": { name: "Casino", city: "Casino", country: "Australia" },
  "CSN": { name: "Carson City", city: "Carson City", country: "USA" },
  "CST": { name: "Castaway", city: "Castaway", country: "Fiji" },
  "CTA": { name: "Catania", city: "Catania", country: "Italy" },
  "CTG": { name: "Rafael Núñez International Airport", city: "Cartagena", country: "Colombia" },
  "CTN": { name: "Cooktown", city: "Cooktown", country: "Australia" },
  "CTS": { name: "New Chitose Airport", city: "Sapporo", country: "Japan" },
  "CTU": { name: "Shuangliu International Airport", city: "Chengdu", country: "China" },
  "CUL": { name: "Culiacan", city: "Culiacan", country: "Mexico" },
  "CUN": { name: "Cancun", city: "Cancun", country: "Mexico" },
  "CUR": { name: "Hato International Airport", city: "Curacao", country: "Curaçao" },
  "CUU": { name: "Gen Fierro Villalobos", city: "Chihuahua", country: "Mexico" },
  "CVG": { name: "Cincinnati/Northern Kentucky International", city: "Cincinnati", country: "USA" },
  "CVM": { name: "Ciudad Victoria", city: "Ciudad Victoria", country: "Mexico" },
  "CVQ": { name: "Carnarvon", city: "Carnarvon", country: "Australia" },
  "CVT": { name: "Baginton", city: "Coventry", country: "United Kingdom" },
  "CWA": { name: "Wausau/Stevens Point", city: "Wausau/Stevens Point", country: "USA" },
  "CWB": { name: "Afonso Pena International Airport", city: "Curitiba", country: "Brazil" },
  "CWL": { name: "Cardiff", city: "Cardiff", country: "United Kingdom" },
  "CXI": { name: "Cassidy International Airport", city: "Kiritimati", country: "Kiribati" },
  "CXT": { name: "Charters Towers", city: "Charters Towers", country: "Australia" },
  "CYS": { name: "Cheyenne Regional Airport", city: "Cheyenne", country: "USA" },
  "CYU": { name: "Cuyo", city: "Cuyo", country: "Philippines" },
  "CZA": { name: "Chichen Itza", city: "Chichen Itza", country: "Mexico" },
  "CZL": { name: "Constantine", city: "Constantine", country: "Algeria" },
  "CZM": { name: "Cozmel", city: "Cozmel", country: "Mexico" },
  "DAB": { name: "Daytona Beach", city: "Daytona Beach", country: "USA" },
  "DAC": { name: "Hazrat Shahjalal International Airport", city: "Dhaka", country: "Bangladesh" },
  "DAL": { name: "Dallas (TX) , Love Field", city: "Dallas (TX) , Love Field", country: "USA" },
  "DAM": { name: "Damascus International Airport", city: "Damascus", country: "Syria" },
  "DAN": { name: "Danville", city: "Danville", country: "USA" },
  "DAR": { name: "Julius Nyerere International Airport", city: "Dar es Salaam", country: "Tanzania" },
  "DAY": { name: "Dayton", city: "Dayton", country: "USA" },
  "DBO": { name: "Dubbo", city: "Dubbo", country: "Australia" },
  "DBQ": { name: "Dubuque IA", city: "Dubuque IA", country: "USA" },
  "DBV": { name: "Dubrovnik", city: "Dubrovnik", country: "Croatia" },
  "DBY": { name: "Dalby", city: "Dalby", country: "Australia" },
  "DCA": { name: "Ronald Reagan National Airport", city: "Washington D.C.", country: "USA" },
  "DDI": { name: "Daydream Island", city: "Daydream Island", country: "Australia" },
  "DEC": { name: "Decatur", city: "Decatur", country: "USA" },
  "DEL": { name: "Indira Gandhi International Airport", city: "Delhi", country: "India" },
  "DEN": { name: "Denver International Airport", city: "Denver", country: "USA" },
  "DET": { name: "Detroit (MI) , Coleman A. Young Municipal", city: "Detroit (MI) , Coleman A. Young Municipal", country: "USA" },
  "DFW": { name: "DFW International", city: "Dallas/Fort Worth", country: "USA" },
  "DHA": { name: "Dhahran", city: "Dhahran", country: "Saudi Arabia" },
  "DHN": { name: "Dothan", city: "Dothan", country: "USA" },
  "DIL": { name: "Nicolau Lobato International Airport", city: "Dili", country: "Timor Leste (East Timor)" },
  "DJB": { name: "Sultan Taha Syarifudn", city: "Jambi", country: "Indonesia" },
  "DJE": { name: "Djerba", city: "Djerba", country: "Tunisia" },
  "DJJ": { name: "Sentani", city: "Jayapura", country: "Indonesia" },
  "DJO": { name: "Daloa", city: "Daloa", country: "Cote d'Ivoire" },
  "DKI": { name: "Dunk Island", city: "Dunk Island", country: "Australia" },
  "DKR": { name: "Léopold Sédar Senghor International Airport", city: "Dakar", country: "Senegal" },
  "DLA": { name: "Douala", city: "Douala", country: "Cameroon" },
  "DLC": { name: "Zhoushuizi International Airport", city: "Dalian", country: "China" },
  "DLG": { name: "Dillingham", city: "Dillingham", country: "USA" },
  "DLH": { name: "Duluth (MN) /Superior", city: "Duluth (MN) /Superior", country: "USA" },
  "DLM": { name: "Dalaman", city: "Dalaman", country: "Turkey" },
  "DLP": { name: "Disneyland Paris", city: "Disneyland Paris", country: "France" },
  "DME": { name: "Domodedovo Mikhail Lomonosov International", city: "Moscow", country: "Russia" },
  "DMK": { name: "Don Mueang", city: "Bangkok", country: "Thailand" },
  "DMM": { name: "King Fahd International Airport", city: "Dammam", country: "Saudi Arabia" },
  "DND": { name: "Dundee", city: "Dundee", country: "United Kingdom" },
  "DNR": { name: "Dinard", city: "Dinard", country: "France" },
  "DNZ": { name: "Denizli", city: "Denizli", country: "Turkey" },
  "DOD": { name: "Dodoma Airport", city: "Dodoma", country: "Tanzania" },
  "DOH": { name: "Hamad International Airport", city: "Doha", country: "Qatar" },
  "DOM": { name: "Melville Hall", city: "Melville Hall", country: "Dominica" },
  "DPO": { name: "Devonport", city: "Devonport", country: "Australia" },
  "DPS": { name: "Ngurah Rai International Airport", city: "Denpasar", country: "Indonesia" },
  "DRB": { name: "Derby", city: "Derby", country: "Australia" },
  "DRO": { name: "Durango", city: "Durango", country: "USA" },
  "DRS": { name: "Dresden Airport", city: "Dresden", country: "Germany" },
  "DRW": { name: "Darwin", city: "Darwin", country: "Australia" },
  "DSA": { name: "Sheffield, Doncaster, Robin Hood International Airport", city: "Sheffield, Doncaster, Robin Hood International Airport", country: "United Kingdom" },
  "DSK": { name: "Dera Ismail Khan Airport", city: "Dera Ismail Khan", country: "Pakistan" },
  "DSM": { name: "Des Moines International Airport", city: "Des Moines", country: "USA" },
  "DSS": { name: "Blaise Diagne International Airport", city: "Dakar", country: "Senegal" },
  "DTM": { name: "Dortmund", city: "Dortmund", country: "Germany" },
  "DTT": { name: "Detroit (MI) , Metropolitan Area", city: "Detroit (MI) , Metropolitan Area", country: "USA" },
  "DTW": { name: "Detroit Metropolitan Airport", city: "Detroit", country: "USA" },
  "DUB": { name: "Dublin Airport", city: "Dublin", country: "Ireland" },
  "DUD": { name: "Dunedin", city: "Dunedin", country: "New Zealand" },
  "DUJ": { name: "Dubois", city: "Dubois", country: "USA" },
  "DUR": { name: "Durban", city: "Durban", country: "South Africa" },
  "DUS": { name: "Dusseldorf", city: "Dusseldorf", country: "Germany" },
  "DUT": { name: "Dutch Harbor", city: "Dutch Harbor", country: "USA" },
  "DVL": { name: "Devils Lake", city: "Devils Lake", country: "USA" },
  "DWC": { name: "Al Maktoum International Airport", city: "Dubai", country: "United Arab Emirates" },
  "DXB": { name: "Dubai International Airport", city: "Dubai", country: "United Arab Emirates" },
  "DYA": { name: "Dysart", city: "Dysart", country: "Australia" },
  "DYU": { name: "Dushanbe Airport", city: "Dushanbe", country: "Tajikistan" },
  "DZA": { name: "Dzaoudzi", city: "Dzaoudzi", country: "Mayotte" },
  "EAP": { name: "Basel/Mulhouse", city: "Basel/Mulhouse", country: "Switzerland/France" },
  "EAS": { name: "San Sebastian", city: "San Sebastian", country: "Spain" },
  "EAT": { name: "Wenatchee", city: "Wenatchee", country: "USA" },
  "EAU": { name: "Eau Clarie", city: "Eau Clarie", country: "USA" },
  "EBA": { name: "Elba Island, Marina Di Campo", city: "Elba Island, Marina Di Campo", country: "Italy" },
  "EBB": { name: "Entebbe International Airport", city: "Entebbe", country: "Uganda" },
  "EBJ": { name: "Esbjerg", city: "Esbjerg", country: "Denmark" },
  "EBU": { name: "St. Etienne", city: "St. Etienne", country: "France" },
  "EDI": { name: "Edinburgh", city: "Edinburgh", country: "United Kingdom" },
  "EDR": { name: "Emerald", city: "Emerald", country: "Australia" },
  "EGC": { name: "Roumanieres", city: "Bergerac", country: "France" },
  "EGE": { name: "Vail", city: "Vail", country: "USA" },
  "EGS": { name: "Egilsstadir", city: "Egilsstadir", country: "Iceland" },
  "EIN": { name: "Eindhoven", city: "Eindhoven", country: "Netherlands" },
  "EIS": { name: "Terrance B. Lettsome", city: "Beef Island", country: "Virgin Islands (British)" },
  "EKI": { name: "Elkhart", city: "Elkhart", country: "USA" },
  "EKO": { name: "Elko", city: "Elko", country: "USA" },
  "ELH": { name: "North Eleuthera", city: "North Eleuthera", country: "Bahamas" },
  "ELL": { name: "Ellisras", city: "Ellisras", country: "South Africa" },
  "ELM": { name: "Elmira", city: "Elmira", country: "USA" },
  "ELP": { name: "El Paso International Airport", city: "El Paso", country: "USA" },
  "ELS": { name: "East London", city: "East London", country: "South Africa" },
  "ELY": { name: "Ely", city: "Ely", country: "USA" },
  "EMA": { name: "East Midlands", city: "Nottingham", country: "United Kingdom" },
  "EMD": { name: "Emerald", city: "Emerald", country: "Australia" },
  "EMY": { name: "El Minya", city: "El Minya", country: "Egypt" },
  "ENA": { name: "Kenai", city: "Kenai", country: "USA" },
  "ENC": { name: "Nancy", city: "Nancy", country: "France" },
  "ENF": { name: "Enontekioe", city: "Enontekioe", country: "Finland" },
  "EPR": { name: "Esperance", city: "Esperance", country: "Australia" },
  "ERC": { name: "Erzincan", city: "Erzincan", country: "Turkey" },
  "ERF": { name: "Erfurt Airport (Flughafen Erfurt)", city: "Erfurt", country: "Germany" },
  "ERI": { name: "Erie", city: "Erie", country: "USA" },
  "ERS": { name: "Eros", city: "Windhoek", country: "Namibia" },
  "ERZ": { name: "Erzurum", city: "Erzurum", country: "Turkey" },
  "ESB": { name: "Esenboğa International Airport", city: "Ankara", country: "Turkey" },
  "ESC": { name: "Escanaba", city: "Escanaba", country: "USA" },
  "ESF": { name: "Esler Field", city: "Alexandria", country: "USA (LA)" },
  "ETH": { name: "Elat", city: "Elat", country: "Israel" },
  "ETZ": { name: "Metz/Nancy Metz-Nancy-Lorraine", city: "Metz/Nancy Metz-Nancy-Lorraine", country: "France" },
  "EUG": { name: "Eugene", city: "Eugene", country: "USA" },
  "EVE": { name: "Evenes", city: "Evenes", country: "Norway" },
  "EVN": { name: "Zvartnots International Airport", city: "Erevan", country: "Armenia" },
  "EVV": { name: "Evansville", city: "Evansville", country: "USA" },
  "EWN": { name: "New Bern", city: "New Bern", country: "USA" },
  "EWR": { name: "Newark Liberty International Airport", city: "New York", country: "USA" },
  "EXT": { name: "Exeter", city: "Exeter", country: "United Kingdom" },
  "EYW": { name: "Key West", city: "Key West", country: "USA" },
  "EZE": { name: "Ezeiza International Airport", city: "Buenos Aires", country: "Argentina" },
  "FAE": { name: "Vágar Airport", city: "Faroer", country: "Denmark" },
  "FAI": { name: "Fairbanks", city: "Fairbanks", country: "USA" },
  "FAO": { name: "Faro", city: "Faro", country: "Portugal" },
  "FAR": { name: "Fargo (ND)", city: "Fargo (ND)", country: "USA" },
  "FAT": { name: "Fresno", city: "Fresno", country: "USA" },
  "FAY": { name: "Fayetteville/Ft. Bragg", city: "Fayetteville/Ft. Bragg", country: "USA" },
  "FBM": { name: "Lumbumbashi", city: "Lumbumbashi", country: "Congo (DRC)" },
  "FBU": { name: "Fornebu", city: "Oslo", country: "Norway" },
  "FCA": { name: "Kalispell", city: "Kalispell", country: "USA" },
  "FCO": { name: "Leonardo da Vinci–Fiumicino Airport", city: "Rome", country: "Italy" },
  "FDF": { name: "Martinique Aimé Césaire International", city: "Fort de France", country: "Martinique" },
  "FDH": { name: "Bodensee-Airport Friedrichshafen", city: "Friedrichshafen", country: "Germany" },
  "FEZ": { name: "Fes", city: "Fes", country: "Morocco" },
  "FHU": { name: "Fort Huachuca/Sierra Vista", city: "Fort Huachuca/Sierra Vista", country: "USA" },
  "FIE": { name: "Fair Isle", city: "Fair Isle", country: "United Kingdom" },
  "FIH": { name: "N'Djili Airport", city: "Kinshasa", country: "Congo (DRC)" },
  "FJR": { name: "Fujairah, International Airport", city: "Fujairah, International Airport", country: "United Arab Emirates" },
  "FKB": { name: "Soellingen", city: "Karlsruhe-Baden", country: "Germany" },
  "FKI": { name: "Kisangani", city: "Kisangani", country: "Congo (DRC)" },
  "FKL": { name: "Franklin/Oil City", city: "Franklin/Oil City", country: "USA" },
  "FKS": { name: "Fukushima Airport", city: "Fukushima", country: "Japan" },
  "FLG": { name: "Flagstaff", city: "Flagstaff", country: "USA" },
  "FLL": { name: "Hollywood International", city: "Fort Lauderdale", country: "USA" },
  "FLN": { name: "Florianopolis", city: "Florianopolis", country: "Brazil" },
  "FLO": { name: "Florence", city: "Florence", country: "USA" },
  "FLR": { name: "Amerigo Vespucci Airport", city: "Florence", country: "Italy" },
  "FMN": { name: "Farmington", city: "Farmington", country: "USA" },
  "FMO": { name: "Muenster/Osnabrueck", city: "Muenster/Osnabrueck", country: "Germany" },
  "FMY": { name: "Fort Myers, Metropolitan Area", city: "Fort Myers, Metropolitan Area", country: "USA" },
  "FNA": { name: "Lungi International Airport", city: "Freetown", country: "Sierra Leone" },
  "FNC": { name: "Funchal", city: "Funchal", country: "Portugal" },
  "FNI": { name: "Nimes", city: "Nimes", country: "France" },
  "FNJ": { name: "Sunan International Airport", city: "Pyongyang", country: "North Korea" },
  "FNT": { name: "Flint", city: "Flint", country: "USA" },
  "FOD": { name: "Fort Dodge IA", city: "Fort Dodge IA", country: "USA" },
  "FOR": { name: "Pinto Martins Airport", city: "Fortaleza", country: "Brazil" },
  "FOU": { name: "Foula", city: "Foula", country: "United Kingdom" },
  "FPO": { name: "Grand Bahama International Airport", city: "Freeport", country: "Bahamas" },
  "FRA": { name: "Frankfurt Airport", city: "Frankfurt", country: "Germany" },
  "FRI": { name: "Marshall AAF", city: "Fort Riley", country: "USA" },
  "FRJ": { name: "Frejus", city: "Frejus", country: "France" },
  "FRO": { name: "Floro", city: "Floro", country: "Norway" },
  "FRU": { name: "Manas International Airport", city: "Bishkek", country: "Kyrgyzstan" },
  "FRW": { name: "Francistown", city: "Francistown", country: "Botswana" },
  "FSC": { name: "Figari", city: "Figari", country: "France" },
  "FSD": { name: "Sioux Falls", city: "Sioux Falls", country: "USA" },
  "FSM": { name: "Fort Smith", city: "Fort Smith", country: "USA" },
  "FSP": { name: "St. Pierre, NF", city: "St. Pierre, NF", country: "Canada" },
  "FUE": { name: "Fuerteventura", city: "Fuerteventura", country: "Spain" },
  "FUK": { name: "Fukuoka", city: "Fukuoka", country: "Japan" },
  "FUT": { name: "Futuna", city: "Futuna", country: "Wallis and Futuna Islands" },
  "FWA": { name: "Fort Wayne", city: "Fort Wayne", country: "USA" },
  "FYV": { name: "Fayetteville", city: "Fayetteville", country: "USA" },
  "GAD": { name: "Gadsden", city: "Gadsden", country: "USA" },
  "GAJ": { name: "Yamagata, Junmachi", city: "Yamagata, Junmachi", country: "Japan" },
  "GAU": { name: "Guwahati", city: "Guwahati", country: "India" },
  "GBE": { name: "Sir Seretse Khama International Airport", city: "Gaborone", country: "Botswana" },
  "GCC": { name: "Gilette", city: "Gilette", country: "USA" },
  "GCI": { name: "Guernsey", city: "Guernsey", country: "Channel Islands" },
  "GCM": { name: "Owen Roberts International", city: "Grand Cayman", country: "Cayman Islands" },
  "GCN": { name: "Grand Canyon", city: "Grand Canyon", country: "USA" },
  "GDL": { name: "Miguel Hidalgo y Costilla International", city: "Guadalajara", country: "Mexico" },
  "GDN": { name: "Gdansk", city: "Gdansk", country: "Poland" },
  "GDV": { name: "Glendive", city: "Glendive", country: "USA" },
  "GEG": { name: "Spokane", city: "Spokane", country: "USA" },
  "GEO": { name: "Cheddi Jagan International Airport", city: "Georgetown", country: "Guyana" },
  "GET": { name: "Geraldton", city: "Geraldton", country: "Australia" },
  "GEX": { name: "Geelong", city: "Geelong", country: "Australia" },
  "GFF": { name: "Griffith", city: "Griffith", country: "Australia" },
  "GFK": { name: "Grand Forks", city: "Grand Forks", country: "USA" },
  "GGG": { name: "Longview/Kilgore", city: "Longview/Kilgore", country: "USA" },
  "GGW": { name: "Glasgow", city: "Glasgow", country: "USA" },
  "GHB": { name: "Govenors Harbour", city: "Govenors Harbour", country: "Bahamas" },
  "GIB": { name: "Gibraltar", city: "Gibraltar", country: "Gibraltar" },
  "GIG": { name: "Galeão International Airport", city: "Rio de Janeiro", country: "Brazil" },
  "GIL": { name: "Gilgit Airport", city: "Gilgit", country: "Pakistan" },
  "GIZ": { name: "King Abdullah bin Abdulaziz International Airport", city: "Jazan", country: "Saudi Arabia" },
  "GJL": { name: "Jijel", city: "Jijel", country: "Algeria" },
  "GJT": { name: "Grand Junction", city: "Grand Junction", country: "USA" },
  "GKL": { name: "Great Keppel Island", city: "Great Keppel Island", country: "Australia" },
  "GLA": { name: "Glasgow", city: "Glasgow", country: "United Kingdom" },
  "GLH": { name: "Greenville", city: "Greenville", country: "USA" },
  "GLT": { name: "Gladstone", city: "Gladstone", country: "Australia" },
  "GNB": { name: "Grenoble", city: "Grenoble", country: "France" },
  "GND": { name: "Point Salines Airport also Maurice Bishop", city: "Grenada", country: "Grenada" },
  "GNE": { name: "Ghent", city: "Ghent", country: "Belgium" },
  "GNV": { name: "Gainesville", city: "Gainesville", country: "USA" },
  "GOA": { name: "Genoa", city: "Genoa", country: "Italy" },
  "GOI": { name: "Dabolim Airport", city: "Goa", country: "India" },
  "GOJ": { name: "Strigino International Airport", city: "Nizhny Novgorod", country: "Russia" },
  "GON": { name: "Groton/New London", city: "Groton/New London", country: "USA" },
  "GOO": { name: "Goondiwindi", city: "Goondiwindi", country: "Australia" },
  "GOT": { name: "Landvetter Airport", city: "Gothenburg", country: "Sweden" },
  "GOU": { name: "Garoua", city: "Garoua", country: "Cameroon" },
  "GOV": { name: "Gove", city: "Gove", country: "Australia" },
  "GOZ": { name: "Gorna", city: "Gorna", country: "Bulgaria" },
  "GPA": { name: "Araxos", city: "Araxos", country: "Greece" },
  "GPT": { name: "Gulfport/Biloxi", city: "Gulfport/Biloxi", country: "USA" },
  "GPZ": { name: "Grand Rapids", city: "Grand Rapids", country: "USA" },
  "GRB": { name: "Green Bay", city: "Green Bay", country: "USA" },
  "GRJ": { name: "George", city: "George", country: "South Africa" },
  "GRO": { name: "Gerona", city: "Gerona", country: "Spain" },
  "GRQ": { name: "Eelde", city: "Groningen", country: "Netherlands" },
  "GRR": { name: "Grand Rapids", city: "Grand Rapids", country: "USA" },
  "GRU": { name: "Guarulhos International Airport", city: "Sao Paulo", country: "Brazil" },
  "GRX": { name: "Granada", city: "Granada", country: "Spain" },
  "GRZ": { name: "Graz", city: "Graz", country: "Austria" },
  "GSI": { name: "Guadalcanal", city: "Guadalcanal", country: "Solomon Islands" },
  "GSO": { name: "Greensboro/Winston Salem", city: "Greensboro/Winston Salem", country: "USA" },
  "GSP": { name: "Greenville/Spartanburg", city: "Greenville/Spartanburg", country: "USA" },
  "GTE": { name: "Alyangula", city: "Groote Eylandt", country: "Australia" },
  "GTF": { name: "Great Falls", city: "Great Falls", country: "USA" },
  "GTI": { name: "Guettin", city: "Guettin", country: "Germany" },
  "GTN": { name: "Mount Cook", city: "Mount Cook", country: "New Zealand" },
  "GUA": { name: "La Aurora International Airport", city: "Guatemala City", country: "Guatemala" },
  "GUC": { name: "Gunnison/Crested Butte", city: "Gunnison/Crested Butte", country: "USA" },
  "GUM": { name: "Antonio B. Won Pat International Airport", city: "Guam", country: "Guam" },
  "GVA": { name: "Geneva Airport", city: "Geneva", country: "Switzerland" },
  "GWD": { name: "Gwadar", city: "Gwadar", country: "Pakistan" },
  "GWE": { name: "Gweru", city: "Gweru", country: "Zimbabwe" },
  "GWT": { name: "Westerland, Sylt Airport", city: "Westerland, Sylt Airport", country: "Germany" },
  "GWY": { name: "Galway", city: "Galway", country: "Ireland" },
  "GYD": { name: "Heydar Aliyev International Airport", city: "Baku", country: "Azerbaijan" },
  "GYE": { name: "José Joaquín de Olmedo International", city: "Guayaquil", country: "Ecuador" },
  "GYN": { name: "Goiania, Santa Genoveva Airport", city: "Goiania, Santa Genoveva Airport", country: "Brazil" },
  "GYP": { name: "Gympie", city: "Gympie", country: "Australia" },
  "GZA": { name: "Gaza International Airport", city: "Gaza City", country: "Palestinian Territory" },
  "GZT": { name: "Gaziantep", city: "Gaziantep", country: "Turkey" },
  "HAC": { name: "Hachijo Jima", city: "Hachijo Jima", country: "Japan" },
  "HAG": { name: "Den Haag", city: "Den Haag", country: "Netherlands" },
  "HAH": { name: "Prince Said Ibrahim", city: "Moroni", country: "Comoros (Comores)" },
  "HAJ": { name: "Hannover", city: "Hannover", country: "Germany" },
  "HAM": { name: "Hamburg", city: "Hamburg", country: "Germany" },
  "HAN": { name: "Noi Bai International Airport", city: "Hanoi", country: "Vietnam" },
  "HAP": { name: "Whitsunday Resort", city: "Whitsunday Resort", country: "Australia" },
  "HAR": { name: "Harrisburg Skyport", city: "Harrisburg", country: "USA" },
  "HAU": { name: "Haugesund", city: "Haugesund", country: "Norway" },
  "HAV": { name: "José Martí International", city: "Havana", country: "Cuba" },
  "HBA": { name: "Hobart", city: "Hobart", country: "Australia" },
  "HBE": { name: "Borg el Arab Airport", city: "Alexandria", country: "Egypt" },
  "HDD": { name: "Hyderabad", city: "Hyderabad", country: "Pakistan" },
  "HDN": { name: "Steamboat Springs", city: "Steamboat Springs", country: "USA" },
  "HDY": { name: "Hatyai", city: "Hatyai", country: "Thailand" },
  "HEL": { name: "Helsinki Airport", city: "Helsinki", country: "Finland" },
  "HER": { name: "Heraklion", city: "Heraklion", country: "Greece" },
  "HEW": { name: "Athens, Hellinikon Airport", city: "Athens, Hellinikon Airport", country: "Greece" },
  "HFA": { name: "Haifa", city: "Haifa", country: "Israel" },
  "HFT": { name: "Hammerfest", city: "Hammerfest", country: "Norway" },
  "HGH": { name: "Hangchow", city: "Hangchow", country: "Zhejiang, PR China" },
  "HGO": { name: "Korhogo", city: "Korhogo", country: "Cote d'Ivoire" },
  "HHH": { name: "Hilton Head Island", city: "Hilton Head Island", country: "USA" },
  "HHN": { name: "Frankfurt/Hahn", city: "Frankfurt/Hahn", country: "Germany" },
  "HIB": { name: "Hibbing", city: "Hibbing", country: "USA" },
  "HII": { name: "Lake Havasu City", city: "Lake Havasu City", country: "USA" },
  "HIJ": { name: "Hiroshima International", city: "Hiroshima International", country: "Japan" },
  "HIR": { name: "Honiara Henderson International", city: "Honiara Henderson International", country: "Solomon Islands" },
  "HIS": { name: "Hayman Island", city: "Hayman Island", country: "Australia" },
  "HKD": { name: "Hakodate", city: "Hakodate", country: "Japan" },
  "HKG": { name: "Hong Kong International Airport", city: "Hong Kong", country: "Hong Kong" },
  "HKS": { name: "Hawkins Field", city: "Jackson", country: "USA" },
  "HKT": { name: "Phuket", city: "Phuket", country: "Thailand" },
  "HKY": { name: "Hickory", city: "Hickory", country: "USA" },
  "HLA": { name: "Lanseria", city: "Lanseria", country: "South Africa" },
  "HLH": { name: "Ulanhot", city: "Ulanhot", country: "PR China" },
  "HLN": { name: "Helena", city: "Helena", country: "USA" },
  "HLP": { name: "Halim Perdana Kusuma", city: "Jakarta", country: "Indonesia" },
  "HLT": { name: "Hamilton", city: "Hamilton", country: "Australia" },
  "HLZ": { name: "Hamilton", city: "Hamilton", country: "New Zealand" },
  "HMH": { name: "Home Hill", city: "Home Hill", country: "Australia" },
  "HMO": { name: "Gen. Pesqueira Garcia", city: "Hermosillo", country: "Mexico" },
  "HNA": { name: "Morioka, Hanamaki", city: "Morioka, Hanamaki", country: "Japan" },
  "HND": { name: "Haneda Airport", city: "Tokyo", country: "Japan" },
  "HNH": { name: "Hoonah", city: "Hoonah", country: "USA" },
  "HNK": { name: "Hinchinbrook Island", city: "Hinchinbrook Island", country: "Australia" },
  "HNL": { name: "Daniel K. Inouye International Airport", city: "Honolulu", country: "USA" },
  "HNS": { name: "Haines", city: "Haines", country: "USA" },
  "HOG": { name: "Holguin", city: "Holguin", country: "Cuba" },
  "HOM": { name: "Homer", city: "Homer", country: "USA" },
  "HON": { name: "Huron", city: "Huron", country: "USA" },
  "HOQ": { name: "Hof", city: "Hof", country: "Germany" },
  "HOR": { name: "Horta", city: "Horta", country: "Portugal" },
  "HOU": { name: "Houston (TX) , Hobby", city: "Houston (TX) , Hobby", country: "USA" },
  "HPN": { name: "White Plains", city: "White Plains", country: "USA" },
  "HRB": { name: "Harbin", city: "Harbin", country: "Heilongjiang, PR China" },
  "HRE": { name: "Robert Gabriel Mugabe International Airport", city: "Harare", country: "Zimbabwe" },
  "HRG": { name: "Hurghada International", city: "Hurghada International", country: "Egypt" },
  "HRK": { name: "Kharkov", city: "Kharkov", country: "Ukraine" },
  "HRL": { name: "Harlingen/South Padre Island", city: "Harlingen/South Padre Island", country: "USA" },
  "HSV": { name: "Huntsville", city: "Huntsville", country: "USA" },
  "HTA": { name: "Chita", city: "Chita", country: "Russia" },
  "HTI": { name: "Hamilton Island", city: "Hamilton Island", country: "Australia" },
  "HTS": { name: "Huntington", city: "Huntington", country: "USA" },
  "HUF": { name: "Terre Haute", city: "Terre Haute", country: "USA" },
  "HUH": { name: "Huahine", city: "Huahine", country: "French Polynesia" },
  "HUI": { name: "Phu Bai", city: "Hue", country: "Viet Nam" },
  "HUX": { name: "Huatulco", city: "Huatulco", country: "Mexico" },
  "HUY": { name: "Humberside", city: "Humberside", country: "United Kingdom" },
  "HVB": { name: "Hervey Bay", city: "Hervey Bay", country: "Australia" },
  "HVN": { name: "New Haven", city: "New Haven", country: "USA" },
  "HVR": { name: "Havre", city: "Havre", country: "USA" },
  "HWN": { name: "Hwange National Park", city: "Hwange National Park", country: "Zimbabwe" },
  "HYA": { name: "Hyannis", city: "Hyannis", country: "USA" },
  "HYD": { name: "Rajiv Gandhi International Airport", city: "Hyderabad", country: "India" },
  "HYG": { name: "Hydaburg", city: "Hydaburg", country: "USA" },
  "IAD": { name: "Dulles International Airport", city: "Washington D.C.", country: "USA" },
  "IAG": { name: "Niagara Falls International", city: "Niagara Falls International", country: "USA" },
  "IAH": { name: "George Bush Intercontinental Airport", city: "Houston", country: "USA" },
  "IBZ": { name: "Ibiza", city: "Ibiza", country: "Spain" },
  "ICN": { name: "Incheon International Airport", city: "Seoul", country: "South Korea" },
  "ICT": { name: "Wichita", city: "Wichita", country: "USA" },
  "IDA": { name: "Idaho Falls", city: "Idaho Falls", country: "USA" },
  "IEV": { name: "Zhulhany", city: "Kiev", country: "Ukraine" },
  "IFL": { name: "Innisfail", city: "Innisfail", country: "Australia" },
  "IGH": { name: "Ingham", city: "Ingham", country: "Australia" },
  "IGR": { name: "Iguazu, Cataratas", city: "Iguazu, Cataratas", country: "Argentina" },
  "IJX": { name: "Municipal Airport", city: "Jacksonville", country: "USA" },
  "IKA": { name: "Imam Khomeini International Airport", city: "Tehran", country: "Iran" },
  "IKT": { name: "Irkutsk", city: "Irkutsk", country: "Russia" },
  "ILE": { name: "Killeem", city: "Killeem", country: "USA" },
  "ILI": { name: "Iliamna", city: "Iliamna", country: "USA" },
  "ILM": { name: "Wilmington", city: "Wilmington", country: "USA" },
  "ILP": { name: "Ile des Pins", city: "Ile des Pins", country: "New Caledonia" },
  "ILY": { name: "Islay", city: "Islay", country: "United Kingdom" },
  "IND": { name: "Indianapolis International Airport", city: "Indianapolis", country: "USA" },
  "INI": { name: "Nis", city: "Nis", country: "Serbia" },
  "INL": { name: "International Falls", city: "International Falls", country: "USA" },
  "INN": { name: "Innsbruck", city: "Innsbruck", country: "Austria" },
  "INV": { name: "Inverness", city: "Inverness", country: "United Kingdom" },
  "IOU": { name: "Ile Ouen", city: "Ile Ouen", country: "New Caledonia" },
  "IPC": { name: "Easter Island", city: "Easter Island", country: "Chile" },
  "IPL": { name: "Imperial", city: "Imperial", country: "USA" },
  "IPT": { name: "Williamsport", city: "Williamsport", country: "USA" },
  "IQT": { name: "Iquitos", city: "Iquitos", country: "Peru" },
  "IRG": { name: "Lockhart River", city: "Lockhart River", country: "Australia" },
  "IRO": { name: "Biraro", city: "Biraro", country: "Central African Republic" },
  "ISA": { name: "Mt. Isa", city: "Mt. Isa", country: "Australia" },
  "ISB": { name: "Islamabad International Airport", city: "Islamabad", country: "Pakistan" },
  "ISG": { name: "New Ishigaki Airport", city: "Ishigaki", country: "Japan" },
  "ISL": { name: "Williston", city: "Williston", country: "USA" },
  "ISO": { name: "Kingston", city: "Kingston", country: "USA" },
  "ISP": { name: "Mac Arthur", city: "Long Island, Islip", country: "USA" },
  "IST": { name: "Istanbul Airport", city: "Istanbul", country: "Turkey" },
  "ITH": { name: "Ithaca/Cortland", city: "Ithaca/Cortland", country: "USA" },
  "ITM": { name: "Itami", city: "Osaka", country: "Japan" },
  "ITO": { name: "Hilo", city: "Hilo", country: "USA" },
  "IVC": { name: "Invercargill", city: "Invercargill", country: "New Zealand" },
  "IVL": { name: "Ivalo", city: "Ivalo", country: "Finland" },
  "IXB": { name: "Bagdogra", city: "Bagdogra", country: "India" },
  "IXC": { name: "Chandigarh International Airport", city: "Chandigarh", country: "India" },
  "IXG": { name: "Belgaum", city: "Belgaum", country: "India" },
  "IXJ": { name: "Satwari", city: "Jammu", country: "India" },
  "IXR": { name: "Ranchi", city: "Ranchi", country: "India" },
  "IXW": { name: "Sonari Airport", city: "Jamshedpur", country: "India" },
  "IYK": { name: "Inykern", city: "Inykern", country: "USA" },
  "IZM": { name: "Izmir", city: "Izmir", country: "Turkey" },
  "JAA": { name: "Jalalabad", city: "Jalalabad", country: "Afghanistan" },
  "JAC": { name: "Jackson Hole (WY)", city: "Jackson Hole", country: "USA" },
  "JAD": { name: "Jandakot", city: "Jandakot", country: "Australia" },
  "JAF": { name: "Kankesanturai", city: "Jaffna", country: "Sri Lanka" },
  "JAG": { name: "Jacobabad", city: "Jacobabad", country: "Pakistan" },
  "JAI": { name: "Sanganeer", city: "Jaipur", country: "India" },
  "JAK": { name: "Jacmel", city: "Jacmel", country: "Haiti" },
  "JAL": { name: "Jalapa", city: "Jalapa", country: "Mexico" },
  "JAM": { name: "Jambol", city: "Jambol", country: "Bulgaria" },
  "JAN": { name: "Jackson Internationall", city: "Jackson", country: "USA" },
  "JAQ": { name: "Jacquinot Bay", city: "Jacquinot Bay", country: "Papua New Guinea" },
  "JAU": { name: "Jauja", city: "Jauja", country: "Peru" },
  "JAX": { name: "Jacksonville International Airport", city: "Jacksonville", country: "USA" },
  "JBR": { name: "Jonesboro (AR)  Jonesboro Airport", city: "Jonesboro (AR)  Jonesboro Airport", country: "USA" },
  "JCB": { name: "Joacaba", city: "Joacaba", country: "Brazil" },
  "JCK": { name: "Julia Creek", city: "Julia Creek", country: "Australia" },
  "JCM": { name: "Jacobina", city: "Jacobina", country: "Brazil" },
  "JDF": { name: "Francisco De Assis Airport", city: "Juiz De Fora", country: "Brazil" },
  "JDH": { name: "Jodhpur", city: "Jodhpur", country: "India" },
  "JDZ": { name: "Jingdezhen", city: "Jingdezhen", country: "PR China" },
  "JED": { name: "King Abdulaziz International Airport", city: "Jeddah", country: "Saudi Arabia" },
  "JEE": { name: "Jeremie Airport", city: "Jeremie", country: "Haiti" },
  "JEF": { name: "Jefferson Memorial", city: "Jefferson City", country: "USA" },
  "JER": { name: "Jersey", city: "Jersey", country: "United Kingdom" },
  "JFK": { name: "John F. Kennedy International Airport", city: "New York", country: "USA" },
  "JGA": { name: "Govardhanpur", city: "Jamnagar", country: "India" },
  "JGB": { name: "Jagdalpur", city: "Jagdalpur", country: "India" },
  "JGN": { name: "Jiayuguan Airport", city: "Jiayuguan", country: "PR China" },
  "JGS": { name: "Ji'an", city: "Ji'an", country: "Jiangxi, China" },
  "JHB": { name: "Sultan Ismail International", city: "Johor Bahru", country: "Malaysia" },
  "JHE": { name: "Helsingborg", city: "Helsingborg", country: "Sweden" },
  "JHG": { name: "Gasa Airport", city: "Jinghong", country: "PR China" },
  "JHM": { name: "Kapalua West", city: "Kapalua West", country: "USA" },
  "JHQ": { name: "Shute Harbour", city: "Shute Harbour", country: "Australia" },
  "JHW": { name: "Jamestown", city: "Jamestown", country: "USA" },
  "JIB": { name: "Djibouti–Ambouli International Airport", city: "Djibouti", country: "Djibouti" },
  "JIJ": { name: "Jijiga", city: "Jijiga", country: "Ethiopia" },
  "JIL": { name: "Jilin", city: "Jilin", country: "PR China" },
  "JIM": { name: "Jimma", city: "Jimma", country: "Ethiopia" },
  "JIN": { name: "Jinja", city: "Jinja", country: "Uganda" },
  "JIP": { name: "Jipijapa", city: "Jipijapa", country: "Ecuador" },
  "JIR": { name: "Jiri", city: "Jiri", country: "Nepal" },
  "JIU": { name: "Jiujiang Lushan Airport", city: "Jiujiang", country: "PR China" },
  "JIW": { name: "Jiwani", city: "Jiwani", country: "Pakistan" },
  "JJI": { name: "Juanjui", city: "Juanjui", country: "Peru" },
  "JJN": { name: "Jinjiang", city: "Jinjiang", country: "PR China" },
  "JKG": { name: "Axamo Airport", city: "Jönköping", country: "Sweden" },
  "JKH": { name: "Chios", city: "Chios", country: "Greece" },
  "JKR": { name: "Janakpur", city: "Janakpur", country: "Nepal" },
  "JKT": { name: "Metropolitan Area", city: "Jakarta", country: "Indonesia" },
  "JKV": { name: "Jacksonville", city: "Jacksonville", country: "USA" },
  "JLN": { name: "Joplin", city: "Joplin", country: "USA" },
  "JLR": { name: "Jalandhar", city: "Jalandhar", country: "India" },
  "JLS": { name: "Jales", city: "Jales", country: "Brazil" },
  "JMB": { name: "Jamba", city: "Jamba", country: "Angola" },
  "JMK": { name: "Mykonos", city: "Mykonos", country: "Greece" },
  "JMO": { name: "Jomsom", city: "Jomsom", country: "Nepal" },
  "JMS": { name: "Jamestown", city: "Jamestown", country: "USA" },
  "JMU": { name: "Jiamusi Airport", city: "Jiamusi", country: "PR China" },
  "JNA": { name: "Januaria", city: "Januaria", country: "Brazil" },
  "JNB": { name: "O. R. Tambo International Airport", city: "Johannesburg", country: "South Africa" },
  "JNG": { name: "Jining", city: "Jining", country: "PR China" },
  "JNI": { name: "Junin", city: "Junin", country: "Argentina" },
  "JNU": { name: "Juneau International Airport", city: "Juneau", country: "USA" },
  "JNX": { name: "Naxos Airport", city: "Naxos", country: "Greece" },
  "JNZ": { name: "Jinzhou Airport", city: "Jinzhou", country: "PR China" },
  "JOE": { name: "Joensuu", city: "Joensuu", country: "Finland" },
  "JOI": { name: "Cubatao Airport", city: "Joinville", country: "Brazil" },
  "JOL": { name: "Jolo", city: "Jolo", country: "Philippines" },
  "JON": { name: "Johnston Island", city: "Johnston Island", country: "USA" },
  "JOS": { name: "Jos", city: "Jos", country: "Nigeria" },
  "JPA": { name: "Castro Pinto Airport", city: "Joao Pessoa", country: "Brazil" },
  "JQE": { name: "Jaque", city: "Jaque", country: "Panama" },
  "JRH": { name: "Rowriah Airport", city: "Jorhat", country: "India" },
  "JRO": { name: "Kilimadjaro", city: "Kilimadjaro", country: "Tanzania" },
  "JRS": { name: "Atarot Airport (closed)", city: "Jerusalem", country: "Israel" },
  "JSA": { name: "Jaisalmer", city: "Jaisalmer", country: "India" },
  "JSI": { name: "Skiathos", city: "Skiathos", country: "Greece" },
  "JSM": { name: "Jose De San Martin", city: "Jose De San Martin", country: "Argentina" },
  "JSR": { name: "Jessore Airport", city: "Jessore", country: "Bangladesh" },
  "JST": { name: "Johnstown", city: "Johnstown", country: "USA" },
  "JTI": { name: "Jatai", city: "Jatai", country: "Brazil" },
  "JTR": { name: "Thira", city: "Thira", country: "Greece" },
  "JUB": { name: "Juba", city: "Juba", country: "South Sudan" },
  "JUI": { name: "Juist", city: "Juist", country: "Germany" },
  "JUJ": { name: "El Cadillal Airport", city: "Jujuy", country: "Argentina" },
  "JUL": { name: "Juliaca", city: "Juliaca", country: "Peru" },
  "JUM": { name: "Jumla", city: "Jumla", country: "Nepal" },
  "JUN": { name: "Jundah", city: "Jundah", country: "Australia" },
  "JUT": { name: "Juticalpa", city: "Juticalpa", country: "Honduras" },
  "JUV": { name: "Upernavik Heliport", city: "Upernavik", country: "Greenland" },
  "JVL": { name: "Rock County", city: "Janesville", country: "USA" },
  "JWA": { name: "Jwaneng", city: "Jwaneng", country: "Botswana" },
  "JXN": { name: "Reynolds Municipal", city: "Jackson", country: "USA" },
  "JYV": { name: "Jyväskylä", city: "Jyväskylä", country: "Finland" },
  "KAJ": { name: "Kajaani", city: "Kajaani", country: "Finland" },
  "KAN": { name: "Kano", city: "Kano", country: "Nigeria" },
  "KAO": { name: "Kuusamo", city: "Kuusamo", country: "Finland" },
  "KBL": { name: "Kabul International Airport", city: "Kabul", country: "Afghanistan" },
  "KBP": { name: "Borispol", city: "Kiev", country: "Ukraine" },
  "KBY": { name: "Streaky Bay", city: "Streaky Bay", country: "Australia" },
  "KCC": { name: "Coffmann Cove", city: "Coffmann Cove", country: "USA" },
  "KCE": { name: "Collinsville", city: "Collinsville", country: "Australia" },
  "KCH": { name: "Kuching", city: "Kuching", country: "Malaysia" },
  "KCM": { name: "Maras", city: "Maras", country: "Turkey" },
  "KCZ": { name: "Kochi", city: "Kochi", country: "Japan" },
  "KDD": { name: "Khuzdar", city: "Khuzdar", country: "Pakistan" },
  "KDU": { name: "Skardu", city: "Skardu", country: "Pakistan" },
  "KEF": { name: "Keflavík International Airport", city: "Keflavik", country: "Iceland" },
  "KEL": { name: "Holtenau", city: "Kiel", country: "Germany" },
  "KEM": { name: "Kemi/Tornio", city: "Kemi/Tornio", country: "Finland" },
  "KGC": { name: "Kingscote", city: "Kingscote", country: "Australia" },
  "KGD": { name: "Kaliningrad", city: "Kaliningrad", country: "Russia" },
  "KGI": { name: "Kalgoorlie", city: "Kalgoorlie", country: "Australia" },
  "KGL": { name: "Gregoire Kayibanda", city: "Kigali", country: "Rwanda" },
  "KGS": { name: "Kos", city: "Kos", country: "Greece" },
  "KHH": { name: "Kaohsiung International", city: "Kaohsiung International", country: "Taiwan" },
  "KHI": { name: "Jinnah International Airport", city: "Karachi", country: "Pakistan" },
  "KHJ": { name: "Kauhajoki", city: "Kauhajoki", country: "Finland" },
  "KHV": { name: "Chabarovsk", city: "Chabarovsk", country: "Russia" },
  "KID": { name: "Kristianstad", city: "Kristianstad", country: "Sweden" },
  "KIJ": { name: "Niigata", city: "Niigata", country: "Japan" },
  "KIK": { name: "Kirkuk", city: "Kirkuk", country: "Iraq" },
  "KIM": { name: "Kimberley", city: "Kimberley", country: "South Africa" },
  "KIN": { name: "Norman Manley International Airport", city: "Kingston", country: "Jamaica" },
  "KIR": { name: "Kerry County", city: "Kerry County", country: "Ireland" },
  "KIV": { name: "Chişinău International Airport", city: "Chisinau", country: "Moldova" },
  "KIW": { name: "Kitwe", city: "Kitwe", country: "Zambia" },
  "KIX": { name: "Kansai International Airport", city: "Osaka", country: "Japan" },
  "KKN": { name: "Kirkenes", city: "Kirkenes", country: "Norway" },
  "KLR": { name: "Kalmar", city: "Kalmar", country: "Sweden" },
  "KLU": { name: "Klagenfurt", city: "Klagenfurt", country: "Austria" },
  "KLW": { name: "Klawock", city: "Klawock", country: "USA" },
  "KLX": { name: "Kalamata", city: "Kalamata", country: "Greece" },
  "KLZ": { name: "Kleinsee", city: "Kleinsee", country: "South Africa" },
  "KMI": { name: "Miyazaki", city: "Miyazaki", country: "Japan" },
  "KMJ": { name: "Kumamoto", city: "Kumamoto", country: "Japan" },
  "KMP": { name: "Keetmanshoop", city: "Keetmanshoop", country: "Namibia" },
  "KMQ": { name: "Komatsu", city: "Komatsu", country: "Japan" },
  "KNO": { name: "Kualanamu International Airport", city: "Medan", country: "Indonesia" },
  "KNS": { name: "King Island", city: "King Island", country: "King Island (Australia)" },
  "KNU": { name: "Kanpur", city: "Kanpur", country: "India" },
  "KNX": { name: "Kununurra", city: "Kununurra", country: "Australia" },
  "KOA": { name: "Kona", city: "Kona", country: "USA" },
  "KOI": { name: "Kirkwall", city: "Orkney", country: "United Kingdom" },
  "KOJ": { name: "Kagoshima", city: "Kagoshima", country: "Japan" },
  "KOK": { name: "Kokkola/Pietarsaari", city: "Kokkola/Pietarsaari", country: "Finland" },
  "KRB": { name: "Karumba", city: "Karumba", country: "Australia" },
  "KRK": { name: "John Paul II International Airport", city: "Krakow", country: "Poland" },
  "KRN": { name: "Kiruna", city: "Kiruna", country: "Sweden" },
  "KRP": { name: "Karup", city: "Karup", country: "Denmark" },
  "KRS": { name: "Kristiansand", city: "Kristiansand", country: "Norway" },
  "KRT": { name: "Khartoum International Airport", city: "Khartoum", country: "Sudan" },
  "KSD": { name: "Karlstad", city: "Karlstad", country: "Sweden" },
  "KSL": { name: "Kassala", city: "Kassala", country: "Sudan" },
  "KSU": { name: "Kristiansund", city: "Kristiansund", country: "Norway" },
  "KTA": { name: "Karratha", city: "Karratha", country: "Australia" },
  "KTB": { name: "Thorne Bay", city: "Thorne Bay", country: "USA" },
  "KTM": { name: "Tribhuvan International Airport", city: "Kathmandu", country: "Nepal" },
  "KTN": { name: "Ketchikan", city: "Ketchikan", country: "USA" },
  "KTR": { name: "Katherine", city: "Katherine", country: "Australia" },
  "KTT": { name: "Kittilä", city: "Kittilä", country: "Finland" },
  "KUA": { name: "Kuantan", city: "Kuantan", country: "Malaysia" },
  "KUF": { name: "Kurumoch International Airport", city: "Samara", country: "Russia" },
  "KUH": { name: "Kushiro", city: "Kushiro", country: "Japan" },
  "KUL": { name: "Kuala Lumpur International Airport", city: "Kuala Lumpur", country: "Malaysia" },
  "KUO": { name: "Kuopio", city: "Kuopio", country: "Finland" },
  "KVA": { name: "Kavalla", city: "Kavalla", country: "Greece" },
  "KWI": { name: "Kuwait International Airport", city: "Kuwait City", country: "Kuwait" },
  "KWL": { name: "Liangjiang", city: "Guilin", country: "Guangxi, PR China" },
  "KWM": { name: "Kowanyama", city: "Kowanyama", country: "Australia" },
  "KYA": { name: "Konya", city: "Konya", country: "Turkey" },
  "KYS": { name: "Kars", city: "Kars", country: "Turkey" },
  "KZN": { name: "Kazan International Airport", city: "Kazan", country: "Russia" },
  "LAD": { name: "Quatro de Fevereiro International Airport", city: "Luanda", country: "Angola" },
  "LAE": { name: "Lae Nadzab Airport", city: "Lae", country: "Papua New Guinea" },
  "LAF": { name: "Lafayette", city: "Lafayette", country: "USA" },
  "LAI": { name: "Lannion", city: "Lannion", country: "France" },
  "LAN": { name: "Lansing", city: "Lansing", country: "USA" },
  "LAP": { name: "Leon", city: "La Paz", country: "Mexico" },
  "LAR": { name: "Laramie", city: "Laramie", country: "USA" },
  "LAS": { name: "Harry Reid International Airport", city: "Las Vegas", country: "USA" },
  "LAW": { name: "Lawton", city: "Lawton", country: "USA" },
  "LAX": { name: "LAX International", city: "Los Angeles", country: "USA" },
  "LBA": { name: "Leeds/Bradford", city: "Leeds/Bradford", country: "United Kingdom" },
  "LBB": { name: "Lubbock", city: "Lubbock", country: "USA" },
  "LBE": { name: "Latrobe", city: "Latrobe", country: "USA" },
  "LBG": { name: "Le Bourget", city: "Paris", country: "France" },
  "LBI": { name: "Albi", city: "Albi", country: "France" },
  "LBQ": { name: "Lambarene", city: "Lambarene", country: "Gabon" },
  "LBU": { name: "Labuan", city: "Labuan", country: "Malaysia" },
  "LBV": { name: "Léon-Mba International Airport", city: "Libreville", country: "Gabon" },
  "LCA": { name: "Larnaca", city: "Larnaca", country: "Cyprus" },
  "LCG": { name: "La Coruna", city: "La Coruna", country: "Spain" },
  "LCH": { name: "Lake Charles", city: "Lake Charles", country: "USA" },
  "LCY": { name: "City Airport", city: "London", country: "United Kingdom" },
  "LDC": { name: "Lindeman Island", city: "Lindeman Island", country: "Australia" },
  "LDE": { name: "Lourdes/Tarbes", city: "Lourdes/Tarbes", country: "France" },
  "LDK": { name: "Lidkoeping", city: "Lidkoeping", country: "Sweden" },
  "LDY": { name: "Eglinton", city: "Londonderry", country: "United Kingdom" },
  "LEA": { name: "Learmouth", city: "Learmouth", country: "Australia" },
  "LEB": { name: "Lebanon", city: "Lebanon", country: "USA" },
  "LED": { name: "Pulkovo", city: "St. Petersburg", country: "Russia" },
  "LEI": { name: "Almeria", city: "Almeria", country: "Spain" },
  "LEJ": { name: "Leipzig", city: "Leipzig", country: "Germany" },
  "LEK": { name: "Labe", city: "Labe", country: "Guinea" },
  "LEQ": { name: "Land's End", city: "Land's End", country: "United Kingdom" },
  "LER": { name: "Leinster", city: "Leinster", country: "Australia" },
  "LEX": { name: "Lexington", city: "Lexington", country: "USA" },
  "LEY": { name: "Lelystad", city: "Lelystad", country: "Netherlands" },
  "LFT": { name: "Lafayette, La", city: "Lafayette, La", country: "USA" },
  "LFW": { name: "Gnassingbé Eyadéma International Airport", city: "Lome", country: "Togo" },
  "LGA": { name: "LaGuardia Airport", city: "New York", country: "USA" },
  "LGB": { name: "Long Beach", city: "Long Beach", country: "USA" },
  "LGG": { name: "Liege", city: "Liege", country: "Belgium" },
  "LGK": { name: "Langkawi", city: "Langkawi", country: "Malaysia" },
  "LGW": { name: "Gatwick Airport", city: "London", country: "United Kingdom" },
  "LHE": { name: "Allama Iqbal International Airport", city: "Lahore", country: "Pakistan" },
  "LHR": { name: "Heathrow Airport", city: "London", country: "United Kingdom" },
  "LIF": { name: "Lifou", city: "Lifou", country: "Loyaute, Pazifik" },
  "LIG": { name: "Limoges", city: "Limoges", country: "France" },
  "LIH": { name: "Lihue", city: "Lihue", country: "USA" },
  "LIJ": { name: "Long Island", city: "Long Island", country: "USA" },
  "LIL": { name: "Lille Airport", city: "Lille", country: "France" },
  "LIM": { name: "Jorge Chávez International Airport", city: "Lima", country: "Peru" },
  "LIN": { name: "Linate Airport", city: "Milan", country: "Italy" },
  "LIQ": { name: "Lisala", city: "Lisala", country: "Congo (DRC)" },
  "LIS": { name: "Humberto Delgado Airport", city: "Lisbon", country: "Portugal" },
  "LIT": { name: "Little Rock", city: "Little Rock", country: "USA" },
  "LJU": { name: "Jože Pučnik Airport", city: "Ljubljana", country: "Slovenia" },
  "LKL": { name: "Lakselv", city: "Lakselv", country: "Norway" },
  "LKO": { name: "Lucknow", city: "Lucknow", country: "India" },
  "LLA": { name: "Lulea", city: "Lulea", country: "Sweden" },
  "LLW": { name: "Lilongwe International", city: "Lilongwe", country: "Malawi" },
  "LMM": { name: "Los Mochis", city: "Los Mochis", country: "Mexico" },
  "LMP": { name: "Lampedusa", city: "Lampedusa", country: "Italy" },
  "LMT": { name: "Klamath Fall", city: "Klamath Fall", country: "USA" },
  "LNK": { name: "Lincoln", city: "Lincoln", country: "USA" },
  "LNO": { name: "Leonora", city: "Leonora", country: "Australia" },
  "LNS": { name: "Lancaster", city: "Lancaster", country: "USA" },
  "LNY": { name: "Lanai City", city: "Lanai City", country: "USA" },
  "LNZ": { name: "Hoersching", city: "Linz", country: "Austria" },
  "LON": { name: "London Metropolitan Area", city: "London Metropolitan Area", country: "United Kingdom" },
  "LOS": { name: "Murtala Muhammed International Airport", city: "Lagos", country: "Nigeria" },
  "LPA": { name: "Las Palmas", city: "Las Palmas", country: "Spain" },
  "LPB": { name: "El Alto International Airport", city: "La Paz", country: "Bolivia" },
  "LPL": { name: "Liverpool", city: "Liverpool", country: "United Kingdom" },
  "LPP": { name: "Lappeenranta", city: "Lappeenranta", country: "Finland" },
  "LRD": { name: "Laredo", city: "Laredo", country: "USA" },
  "LRE": { name: "Longreach", city: "Longreach", country: "Australia" },
  "LRF": { name: "Jacksonville (AR)  Little Rock AFB", city: "Jacksonville (AR)  Little Rock AFB", country: "USA" },
  "LRH": { name: "La Rochelle", city: "La Rochelle", country: "France" },
  "LRM": { name: "La Romana International Airport", city: "Casa de Campo", country: "Dominican Republic" },
  "LRT": { name: "Lorient", city: "Lorient", country: "France" },
  "LSE": { name: "La Crosse", city: "La Crosse", country: "USA" },
  "LSI": { name: "Sumburgh", city: "Sumburgh", country: "United Kingdom" },
  "LST": { name: "Launceston", city: "Launceston", country: "Australia" },
  "LSY": { name: "Lismore", city: "Lismore", country: "Australia" },
  "LSZ": { name: "Losinj Arpt", city: "Losinj", country: "Croatia (Hrvatska)" },
  "LTN": { name: "Luton Airport", city: "London", country: "United Kingdom" },
  "LTO": { name: "Loreto", city: "Loreto", country: "Mexico" },
  "LUD": { name: "Luederitz", city: "Luederitz", country: "Namibia" },
  "LUG": { name: "Lugano", city: "Lugano", country: "Switzerland" },
  "LUJ": { name: "Lusisiki", city: "Lusisiki", country: "South Africa" },
  "LUM": { name: "Mangshi", city: "Luxi", country: "Yunnan, PR China" },
  "LUN": { name: "Kenneth Kaunda International Airport", city: "Lusaka", country: "Zambia" },
  "LUX": { name: "Luxembourg", city: "Luxembourg", country: "Luxembourg" },
  "LVO": { name: "Laverton", city: "Laverton", country: "Australia" },
  "LWB": { name: "Greenbrier/Lewisburg", city: "Greenbrier/Lewisburg", country: "USA" },
  "LWK": { name: "Lerwick/Tingwall", city: "Lerwick/Tingwall", country: "United Kingdom" },
  "LWO": { name: "Lvov", city: "Lvov", country: "Ukraine" },
  "LWS": { name: "Lewiston", city: "Lewiston", country: "USA" },
  "LWT": { name: "Lewistown", city: "Lewistown", country: "USA" },
  "LXR": { name: "Luxor", city: "Luxor", country: "Egypt" },
  "LYH": { name: "Lynchburg", city: "Lynchburg", country: "USA" },
  "LYO": { name: "Rice County Municipal", city: "Lyons", country: "USA" },
  "LYP": { name: "Faisalabad", city: "Faisalabad", country: "Pakistan" },
  "LYR": { name: "Svalbard", city: "Longyearbyen", country: "Svalbard/Norway" },
  "LYS": { name: "Lyon–Saint Exupéry Airport", city: "Lyon", country: "France" },
  "LYX": { name: "Lydd International Airport", city: "Lydd", country: "United Kingdom" },
  "LZC": { name: "Lazaro Cardenas", city: "Lazaro Cardenas", country: "Mexico" },
  "LZR": { name: "Lizard Island", city: "Lizard Island", country: "Australia" },
  "MAA": { name: "Chennai International Airport", city: "Chennai", country: "India" },
  "MAD": { name: "Adolfo Suárez Madrid–Barajas Airport", city: "Madrid", country: "Spain" },
  "MAF": { name: "Midland/Odessa", city: "Midland/Odessa", country: "USA" },
  "MAH": { name: "Mahon", city: "Mahon", country: "Spain" },
  "MAN": { name: "Manchester", city: "Manchester", country: "United Kingdom" },
  "MAO": { name: "Eduardo Gomes International Airport", city: "Manaus", country: "Brazil" },
  "MAR": { name: "La Chinita International", city: "Maracaibo", country: "Venezuela" },
  "MAU": { name: "Maupiti", city: "Maupiti", country: "French Polynesia" },
  "MAZ": { name: "Mayaguez", city: "Mayaguez", country: "Puerto Rico" },
  "MBA": { name: "Moi International", city: "Mombasa", country: "Kenya" },
  "MBH": { name: "Maryborough", city: "Maryborough", country: "Australia" },
  "MBJ": { name: "Sangster International Airport", city: "Montego Bay", country: "Jamaica" },
  "MBM": { name: "Mkambati", city: "Mkambati", country: "South Africa" },
  "MBS": { name: "Saginaw/Bay City/Midland", city: "Saginaw/Bay City/Midland", country: "USA" },
  "MBX": { name: "Maribor", city: "Maribor", country: "Slovenia" },
  "MCE": { name: "Merced", city: "Merced", country: "USA" },
  "MCI": { name: "Kansas City International Airport", city: "Kansas City", country: "USA" },
  "MCL": { name: "Mt. McKinley", city: "Mt. McKinley", country: "USA" },
  "MCN": { name: "Macon", city: "Macon", country: "USA" },
  "MCO": { name: "Orlando International Airport", city: "Orlando", country: "USA" },
  "MCP": { name: "Alberto Alcolumbre International Airport", city: "Macapa", country: "Brazil" },
  "MCT": { name: "Muscat International Airport", city: "Muscat", country: "Oman" },
  "MCW": { name: "Mason City IA", city: "Mason City IA", country: "USA" },
  "MCY": { name: "Sunshine Coast", city: "Sunshine Coast", country: "Australia" },
  "MCZ": { name: "Zumbi dos Palmares International Airport", city: "Maceio", country: "Brazil" },
  "MDC": { name: "Manado", city: "Manado", country: "Indonesia" },
  "MDE": { name: "José María Córdova International", city: "Medellin", country: "Colombia" },
  "MDL": { name: "Mandalay-Annisaton Airport", city: "Mandalay", country: "Myanmar" },
  "MDQ": { name: "Mar del Plata", city: "Mar del Plata", country: "Argentina" },
  "MDT": { name: "Harrisburg International", city: "Harrisburg", country: "USA" },
  "MDW": { name: "Midway International Airport", city: "Chicago", country: "USA" },
  "MDY": { name: "Sand Island Field", city: "Midway Island", country: "US Minor Outlying Islands" },
  "MDZ": { name: "Mendoza", city: "Mendoza", country: "Argentina" },
  "MED": { name: "Prince Mohammad bin Abdulaziz International", city: "Medina", country: "Saudi Arabia" },
  "MEE": { name: "Mare", city: "Mare", country: "New Caledonia" },
  "MEI": { name: "Meridian", city: "Meridian", country: "USA" },
  "MEL": { name: "Melbourne", city: "Melbourne", country: "Australia" },
  "MEM": { name: "Memphis (TN)", city: "Memphis", country: "USA" },
  "MES": { name: "Polania Int'l (now Soewondo AFB)", city: "Medan", country: "Indonesia" },
  "MEX": { name: "Benito Juárez International Airport", city: "Mexico City", country: "Mexico" },
  "MEZ": { name: "Messina", city: "Messina", country: "South Africa" },
  "MFE": { name: "McAllen", city: "McAllen", country: "USA" },
  "MFF": { name: "Moanda", city: "Moanda", country: "Gabon" },
  "MFG": { name: "Muzaffarabad", city: "Muzaffarabad", country: "Pakistan" },
  "MFM": { name: "Macau International Airport", city: "Macau", country: "Macau, China SAR" },
  "MFN": { name: "Milford Sound", city: "Milford Sound", country: "New Zealand" },
  "MFO": { name: "Manguna", city: "Manguna", country: "Papua New Guinea" },
  "MFQ": { name: "Maradi", city: "Maradi", country: "Niger" },
  "MFR": { name: "Medford", city: "Medford", country: "USA" },
  "MFU": { name: "Mfuwe", city: "Mfuwe", country: "Zambia" },
  "MGA": { name: "Augusto C Sandino", city: "Managua", country: "Nicaragua" },
  "MGB": { name: "Mount Gambier", city: "Mount Gambier", country: "Australia" },
  "MGH": { name: "Margate", city: "Margate", country: "South Africa" },
  "MGM": { name: "Montgomery Regional Airport", city: "Montgomery", country: "USA" },
  "MGQ": { name: "Mogadishu", city: "Mogadishu", country: "Somalia" },
  "MGW": { name: "Morgantown", city: "Morgantown", country: "USA" },
  "MHE": { name: "Mitchell", city: "Mitchell", country: "USA" },
  "MHH": { name: "Marsh Harbour", city: "Marsh Harbour", country: "Bahamas" },
  "MHQ": { name: "Mariehamn", city: "Mariehamn", country: "Finland" },
  "MHT": { name: "Manchester", city: "Manchester", country: "USA" },
  "MIA": { name: "Miami International Airport", city: "Miami", country: "USA" },
  "MID": { name: "Merida", city: "Merida", country: "Mexico" },
  "MIK": { name: "Mikkeli", city: "Mikkeli", country: "Finland" },
  "MIL": { name: "Milan", city: "Milan", country: "Italy" },
  "MIM": { name: "Merimbula", city: "Merimbula", country: "Australia" },
  "MIR": { name: "Monastir", city: "Monastir", country: "Tunisia" },
  "MJC": { name: "Man", city: "Man", country: "Cote d'Ivoire" },
  "MJD": { name: "Moenjodaro", city: "Moenjodaro", country: "Pakistan" },
  "MJL": { name: "Mouila", city: "Mouila", country: "Gabon" },
  "MJN": { name: "Majunga", city: "Majunga", country: "Madagascar" },
  "MJQ": { name: "Jackson,  MN", city: "Jackson,  MN", country: "USA" },
  "MJT": { name: "Mytilene", city: "Mytilene", country: "Greece" },
  "MJV": { name: "Murcia", city: "Murcia", country: "Spain" },
  "MKE": { name: "Milwaukee", city: "Milwaukee", country: "USA" },
  "MKG": { name: "Muskegon", city: "Muskegon", country: "USA" },
  "MKK": { name: "Kaunakakai", city: "Kaunakakai", country: "USA" },
  "MKL": { name: "Mckellar", city: "Jackson", country: "USA" },
  "MKR": { name: "Meekatharra", city: "Meekatharra", country: "Australia" },
  "MKY": { name: "Mackay", city: "Mackay", country: "Australia" },
  "MLA": { name: "Malta International Airport", city: "Malta", country: "Malta" },
  "MLB": { name: "Melbourne", city: "Melbourne", country: "USA" },
  "MLE": { name: "Velana International Airport", city: "Male", country: "Maldives" },
  "MLH": { name: "Mulhouse", city: "Mulhouse", country: "France" },
  "MLI": { name: "Moline/Quad Cities", city: "Moline/Quad Cities", country: "USA" },
  "MLM": { name: "Morelia", city: "Morelia", country: "Mexico" },
  "MLS": { name: "Miles City", city: "Miles City", country: "USA" },
  "MLU": { name: "Monroe", city: "Monroe", country: "USA" },
  "MLW": { name: "Metropolitan Area", city: "Monrovia", country: "Liberia" },
  "MLX": { name: "Malatya", city: "Malatya", country: "Turkey" },
  "MMA": { name: "Malmo", city: "Malmo", country: "Sweden" },
  "MME": { name: "Teesside, Durham Tees Valley", city: "Teesside, Durham Tees Valley", country: "United Kingdom" },
  "MMG": { name: "Mount Magnet", city: "Mount Magnet", country: "Australia" },
  "MMJ": { name: "Matsumoto, Nagano", city: "Matsumoto, Nagano", country: "Japan" },
  "MMK": { name: "Murmansk", city: "Murmansk", country: "Russia" },
  "MMM": { name: "Middlemount", city: "Middlemount", country: "Australia" },
  "MMX": { name: "Malmo", city: "Malmo", country: "Sweden" },
  "MMY": { name: "Hirara", city: "Miyako Jima", country: "Japan" },
  "MNL": { name: "Ninoy Aquino International Airport", city: "Manila", country: "Philippines" },
  "MOB": { name: "Pascagoula (MS)", city: "Mobile", country: "USA" },
  "MOD": { name: "Modesto", city: "Modesto", country: "USA" },
  "MOT": { name: "Minot", city: "Minot", country: "USA" },
  "MOV": { name: "Moranbah", city: "Moranbah", country: "Australia" },
  "MOW": { name: "Metropolitan Area", city: "Moscow", country: "Russia" },
  "MOZ": { name: "Moorea", city: "Moorea", country: "French Polynesia" },
  "MPA": { name: "Katima Mulilo/Mpacha", city: "Katima Mulilo/Mpacha", country: "Namibia" },
  "MPD": { name: "Sindhri", city: "Sindhri", country: "Pakistan" },
  "MPL": { name: "Montpellier–Méditerranée Airport", city: "Montpellier", country: "France" },
  "MPM": { name: "Maputo International Airport", city: "Maputo", country: "Mozambique" },
  "MQL": { name: "Mildura", city: "Mildura", country: "Australia" },
  "MQM": { name: "Mardin", city: "Mardin", country: "Turkey" },
  "MQP": { name: "Kruger Mpumalanga International Airport", city: "Nelspruit", country: "South Africa" },
  "MQQ": { name: "Moundou", city: "Moundou", country: "Chad" },
  "MQT": { name: "Marquette", city: "Marquette", country: "USA" },
  "MRB": { name: "Martinsburg", city: "Martinsburg", country: "USA" },
  "MRS": { name: "Marseille", city: "Marseille", country: "France" },
  "MRU": { name: "Sir Seewoosagur Ramgoolam International", city: "Mauritius", country: "Mauritius" },
  "MRV": { name: "Mineralnye Vody", city: "Mineralnye Vody", country: "Russia" },
  "MRY": { name: "Monterey", city: "Monterey", country: "USA" },
  "MRZ": { name: "Moree", city: "Moree", country: "Australia" },
  "MSE": { name: "Kent (Manston) Kent International", city: "Kent (Manston) Kent International", country: "United Kingdom" },
  "MSL": { name: "Muscle Shoals", city: "Muscle Shoals", country: "USA" },
  "MSN": { name: "Dane County Regional Airport", city: "Madison", country: "USA" },
  "MSO": { name: "Missula", city: "Missula", country: "USA" },
  "MSP": { name: "Minneapolis/St. Paul (MN)", city: "Minneapolis/St. Paul", country: "USA" },
  "MSQ": { name: "Minsk, International", city: "Minsk, International", country: "Belarus" },
  "MSR": { name: "Mus", city: "Mus", country: "Turkey" },
  "MST": { name: "Maastricht/Aachen", city: "Maastricht/Aachen", country: "Netherlands" },
  "MSU": { name: "Moshoeshoe International", city: "Maseru", country: "Lesotho" },
  "MSY": { name: "New Orleans, La", city: "New Orleans, La", country: "USA" },
  "MTH": { name: "Marathon", city: "Marathon", country: "USA" },
  "MTJ": { name: "Montrose/Tellruide", city: "Montrose/Tellruide", country: "USA" },
  "MTL": { name: "Maitland", city: "Maitland", country: "Australia" },
  "MTM": { name: "Metlakatla", city: "Metlakatla", country: "USA" },
  "MTO": { name: "Mattoon", city: "Mattoon", country: "USA" },
  "MTS": { name: "Matsapha International", city: "Manzini", country: "Swaziland" },
  "MTT": { name: "Minatitlan", city: "Minatitlan", country: "Mexico" },
  "MTY": { name: "Gen. Mariano Escobedo", city: "Monterrey", country: "Mexico" },
  "MUB": { name: "Maun", city: "Maun", country: "Botswana" },
  "MUC": { name: "Munich", city: "Munich", country: "Germany" },
  "MUE": { name: "Kamuela", city: "Kamuela", country: "USA" },
  "MUH": { name: "Marsa Matrah", city: "Marsa Matrah", country: "Egypt" },
  "MUX": { name: "Multan International Airport", city: "Multan", country: "Pakistan" },
  "MVB": { name: "Mvengue", city: "Mvengue", country: "Gabon" },
  "MVD": { name: "Carrasco International Airport", city: "Montevideo", country: "Uruguay" },
  "MVR": { name: "Maroua", city: "Maroua", country: "Cameroon" },
  "MVY": { name: "Martha's Vineyard", city: "Martha's Vineyard", country: "USA" },
  "MVZ": { name: "Masvingo", city: "Masvingo", country: "Zimbabwe" },
  "MWD": { name: "Mianwali", city: "Mianwali", country: "Pakistan" },
  "MWH": { name: "Moses Lake", city: "Moses Lake", country: "USA" },
  "MXL": { name: "Mexicali", city: "Mexicali", country: "Mexico" },
  "MXP": { name: "Malpensa Airport", city: "Milan", country: "Italy" },
  "MYA": { name: "Moruya", city: "Moruya", country: "Australia" },
  "MYD": { name: "Malindi", city: "Malindi", country: "Kenya" },
  "MYJ": { name: "Matsuyama", city: "Matsuyama", country: "Japan" },
  "MYQ": { name: "Mysore", city: "Mysore", country: "India" },
  "MYR": { name: "Myrtle Beach AFB", city: "Myrtle Beach", country: "USA" },
  "MYY": { name: "Miri", city: "Miri", country: "Malaysia" },
  "MZF": { name: "Mzamba", city: "Mzamba", country: "South Africa" },
  "MZG": { name: "Makung", city: "Makung", country: "Taiwan" },
  "MZM": { name: "Frescaty", city: "Metz", country: "France" },
  "MZT": { name: "Mazatlan", city: "Mazatlan", country: "Mexico" },
  "MZY": { name: "Mossel Bay", city: "Mossel Bay", country: "South Africa" },
  "NAA": { name: "Narrabri", city: "Narrabri", country: "Australia" },
  "NAG": { name: "Nagpur", city: "Nagpur", country: "India" },
  "NAJ": { name: "Nakhichevan", city: "Nakhichevan", country: "Azerbaijan" },
  "NAN": { name: "Nadi", city: "Nadi", country: "Fiji" },
  "NAP": { name: "Naples Capodichino Airport", city: "Naples", country: "Italy" },
  "NAS": { name: "Lynden Pindling International Airport", city: "Nassau", country: "Bahamas" },
  "NAT": { name: "Augusto Severo International Airport", city: "Natal", country: "Brazil" },
  "NAY": { name: "Nanyuan Airport", city: "Beijing", country: "China" },
  "NBO": { name: "Jomo Kenyatta International Airport", city: "Nairobi", country: "Kenya" },
  "NCE": { name: "Nice Côte d'Azur Airport", city: "Nice", country: "France" },
  "NCL": { name: "Newcastle", city: "Newcastle", country: "United Kingdom" },
  "NCS": { name: "Newcastle", city: "Newcastle", country: "South Africa" },
  "NCY": { name: "Annecy", city: "Annecy", country: "France" },
  "NDB": { name: "Nouadhibou", city: "Nouadhibou", country: "Mauritania" },
  "NDJ": { name: "N'Djamena", city: "N'Djamena", country: "Chad" },
  "NDU": { name: "Rundu", city: "Rundu", country: "Namibia" },
  "NEV": { name: "Nevis", city: "Nevis", country: "St. Kitts and Nevis" },
  "NGE": { name: "N'Gaoundere", city: "N'Gaoundere", country: "Cameroon" },
  "NGO": { name: "Komaki AFB", city: "Nagoya", country: "Japan" },
  "NGS": { name: "Nagasaki", city: "Nagasaki", country: "Japan" },
  "NIC": { name: "Nicosia", city: "Nicosia", country: "Cyprus" },
  "NIM": { name: "Niamey", city: "Niamey", country: "Niger" },
  "NIP": { name: "Jacksonville (FL) Jacksonville NAS", city: "Jacksonville (FL) Jacksonville NAS", country: "USA" },
  "NKC": { name: "Nouakchott", city: "Nouakchott", country: "Mauritania" },
  "NLA": { name: "N'Dola", city: "N'Dola", country: "Zambia" },
  "NLD": { name: "Nuevo Laredo", city: "Nuevo Laredo", country: "Mexico" },
  "NLK": { name: "Norfolk Island", city: "Norfolk Island", country: "Australia" },
  "NLP": { name: "Nelspruit", city: "Nelspruit", country: "South Africa" },
  "NLU": { name: "Santa Lucia", city: "Mexico City", country: "Mexico" },
  "NLV": { name: "Nikolaev", city: "Nikolaev", country: "Ukraine" },
  "NNG": { name: "Nanning", city: "Nanning", country: "Guangxi, PR China" },
  "NOC": { name: "Knock", city: "Knock", country: "Ireland" },
  "NOP": { name: "Nab", city: "Mactan Island", country: "Philippines" },
  "NOU": { name: "Noumea", city: "Noumea", country: "New Caledonia" },
  "NQY": { name: "Newquay", city: "Newquay", country: "United Kingdom" },
  "NQZ": { name: "Nursultan Nazarbayev International Airport", city: "Astana", country: "Kazakhstan" },
  "NRA": { name: "Narrandera", city: "Narrandera", country: "Australia" },
  "NRK": { name: "Norrkoeping", city: "Norrkoeping", country: "Sweden" },
  "NRT": { name: "Narita International Airport", city: "Tokyo", country: "Japan" },
  "NSA": { name: "Noosa", city: "Noosa", country: "Australia" },
  "NSN": { name: "Nelson", city: "Nelson", country: "New Zealand" },
  "NSO": { name: "Scone", city: "Scone", country: "Australia" },
  "NST": { name: "Nakhon Si Thammarat", city: "Nakhon Si Thammarat", country: "Thailand" },
  "NTE": { name: "Nantes Atlantique Airport", city: "Nantes", country: "France" },
  "NTL": { name: "Williamtown", city: "Newcastle", country: "Australia" },
  "NTR": { name: "Aeropuerto Del Norte", city: "Monterrey", country: "Mexico" },
  "NTY": { name: "Pilanesberg/Sun City", city: "Pilanesberg/Sun City", country: "South Africa" },
  "NUE": { name: "Nürnberg", city: "Nürnberg", country: "Germany" },
  "NWI": { name: "Norwich", city: "Norwich", country: "United Kingdom" },
  "NYC": { name: "New York", city: "New York", country: "USA" },
  "NZC": { name: "Cecil Field NAS", city: "Jacksonville", country: "USA" },
  "OAG": { name: "Orange", city: "Orange", country: "Australia" },
  "OAJ": { name: "Jacksonville", city: "Jacksonville", country: "USA" },
  "OAK": { name: "Oakland", city: "Oakland", country: "USA" },
  "OAX": { name: "Xoxocotlan", city: "Oaxaca", country: "Mexico" },
  "ODA": { name: "Ouadda", city: "Ouadda", country: "Central African Republic" },
  "ODB": { name: "Cordoba", city: "Cordoba", country: "Spain" },
  "ODE": { name: "Odense", city: "Odense", country: "Denmark" },
  "ODS": { name: "Odessa", city: "Odessa", country: "Ukraine" },
  "OGG": { name: "Kahului", city: "Kahului", country: "USA" },
  "OHD": { name: "Ohrid", city: "Ohrid", country: "Macedonia" },
  "OHT": { name: "Kohat", city: "Kohat", country: "Pakistan" },
  "OIT": { name: "Oita", city: "Oita", country: "Japan" },
  "OKA": { name: "Naha", city: "Okinawa, Ryukyo Island", country: "Japan" },
  "OKC": { name: "Will Rogers World", city: "Oklahoma City", country: "USA" },
  "OKD": { name: "Okadama", city: "Sapporo", country: "Hokkaido, Japan" },
  "OKJ": { name: "Okayama", city: "Okayama", country: "Japan" },
  "OKU": { name: "Mokuti", city: "Mokuti", country: "Namibia" },
  "OLB": { name: "Olbia", city: "Olbia", country: "Italy" },
  "OLF": { name: "Wolf Point", city: "Wolf Point", country: "USA" },
  "OLP": { name: "Olympic Dam", city: "Olympic Dam", country: "Australia" },
  "OMA": { name: "Omaha", city: "Omaha", country: "USA" },
  "OMD": { name: "Oranjemund", city: "Oranjemund", country: "Namibia" },
  "OME": { name: "Nome", city: "Nome", country: "USA" },
  "OMH": { name: "Urmiehm", city: "Urmiehm", country: "Iran" },
  "OMO": { name: "Mostar", city: "Mostar", country: "Bosnia and Herzegovina" },
  "OND": { name: "Ondangwa", city: "Ondangwa", country: "Namibia" },
  "ONT": { name: "Ontario", city: "Ontario", country: "USA" },
  "OOL": { name: "Gold Coast", city: "Gold Coast", country: "Australia" },
  "OOM": { name: "Cooma", city: "Cooma", country: "Australia" },
  "OPO": { name: "Porto", city: "Porto", country: "Portugal" },
  "ORB": { name: "Oerebro", city: "Oerebro", country: "Sweden" },
  "ORD": { name: "O'Hare International Airport", city: "Chicago", country: "USA" },
  "ORF": { name: "Norfolk/Virginia Beach", city: "Norfolk/Virginia Beach", country: "USA" },
  "ORH": { name: "Worcester", city: "Worcester", country: "USA" },
  "ORK": { name: "Cork", city: "Cork", country: "Ireland" },
  "ORL": { name: "Orlando Metropolitan Area", city: "Orlando Metropolitan Area", country: "USA" },
  "ORN": { name: "Oran", city: "Oran", country: "Algeria" },
  "ORS": { name: "Orpheus Island", city: "Orpheus Island", country: "Australia" },
  "ORY": { name: "Orly Airport", city: "Paris", country: "France" },
  "OSA": { name: "Osaka, Metropolitan Area", city: "Osaka, Metropolitan Area", country: "Japan" },
  "OSH": { name: "Oshkosh", city: "Oshkosh", country: "USA" },
  "OSI": { name: "Osijek", city: "Osijek", country: "Croatia (Hrvatska)" },
  "OSL": { name: "Oslo Airport, Gardermoen", city: "Oslo", country: "Norway" },
  "OSM": { name: "Mosul", city: "Mosul", country: "Iraq" },
  "OTH": { name: "North Bend", city: "North Bend", country: "USA" },
  "OTP": { name: "Henri Coandă International Airport", city: "Bucharest", country: "Romania" },
  "OTZ": { name: "Kotzbue", city: "Kotzbue", country: "USA" },
  "OUA": { name: "Ouagadougou", city: "Ouagadougou", country: "Burkina Faso" },
  "OUD": { name: "Oujda", city: "Oujda", country: "Morocco" },
  "OUH": { name: "Oudtshoorn", city: "Oudtshoorn", country: "South Africa" },
  "OUK": { name: "Out Skerries", city: "Out Skerries", country: "United Kingdom" },
  "OUL": { name: "Oulu", city: "Oulu", country: "Finland" },
  "OUZ": { name: "Zouerate", city: "Zouerate", country: "Mauritania" },
  "OVB": { name: "Tolmachevo Airport", city: "Novosibirsk", country: "Russia" },
  "OVD": { name: "Oviedo", city: "Oviedo", country: "Spain" },
  "OWB": { name: "Owensboro", city: "Owensboro", country: "USA" },
  "OXB": { name: "Osvaldo Vieira International Airport", city: "Bissau", country: "Guinea-Bissau" },
  "OXR": { name: "Oxnard", city: "Oxnard", country: "USA" },
  "OZZ": { name: "Ouarzazate", city: "Ouarzazate", country: "Morocco" },
  "PAD": { name: "Paderborn/Lippstadt", city: "Paderborn/Lippstadt", country: "Germany" },
  "PAH": { name: "Paducah", city: "Paducah", country: "USA" },
  "PAP": { name: "Port au Prince", city: "Port au Prince", country: "Haiti" },
  "PAR": { name: "Paris", city: "Paris", country: "France" },
  "PAT": { name: "Patna", city: "Patna", country: "India" },
  "PBC": { name: "Puebla", city: "Puebla", country: "Mexico" },
  "PBH": { name: "Paro", city: "Paro", country: "Bhutan" },
  "PBI": { name: "West Palm Beach", city: "West Palm Beach", country: "USA" },
  "PBM": { name: "Zanderij International", city: "Paramaribo", country: "Suriname" },
  "PBO": { name: "Paraburdoo", city: "Paraburdoo", country: "Australia" },
  "PBZ": { name: "Plettenberg Bay", city: "Plettenberg Bay", country: "South Africa" },
  "PDL": { name: "Ponta Delgada", city: "Ponta Delgada", country: "Portugal" },
  "PDT": { name: "Pendelton", city: "Pendelton", country: "USA" },
  "PDX": { name: "Portland International", city: "Portland International", country: "USA" },
  "PEG": { name: "Perugia", city: "Perugia", country: "Italy" },
  "PEI": { name: "Pereira", city: "Pereira", country: "Colombia" },
  "PEK": { name: "Beijing Capital International", city: "Beijing", country: "China" },
  "PEN": { name: "Penang International", city: "Penang International", country: "Malaysia" },
  "PER": { name: "Perth", city: "Perth", country: "Australia" },
  "PEW": { name: "Bacha Khan International Airport", city: "Peshawar", country: "Pakistan" },
  "PFN": { name: "Panama City", city: "Panama City", country: "USA" },
  "PFO": { name: "Paphos", city: "Paphos", country: "Cyprus" },
  "PGA": { name: "Page/Lake Powell", city: "Page/Lake Powell", country: "USA" },
  "PGF": { name: "Perpignan", city: "Perpignan", country: "France" },
  "PGV": { name: "Greenville", city: "Greenville", country: "USA" },
  "PHC": { name: "Port Harcourt", city: "Port Harcourt", country: "Nigeria" },
  "PHE": { name: "Port Hedland", city: "Port Hedland", country: "Australia" },
  "PHF": { name: "Newport News/Williamsburg", city: "Newport News/Williamsburg", country: "USA" },
  "PHL": { name: "Philadelphia International", city: "Philadelphia", country: "USA" },
  "PHW": { name: "Phalaborwa", city: "Phalaborwa", country: "South Africa" },
  "PHX": { name: "Sky Harbor International Airport", city: "Phoenix", country: "USA" },
  "PIA": { name: "Peoria/Bloomington", city: "Peoria/Bloomington", country: "USA" },
  "PIB": { name: "Laurel/Hattisburg", city: "Laurel/Hattisburg", country: "USA" },
  "PIH": { name: "Pocatello", city: "Pocatello", country: "USA" },
  "PIK": { name: "Glasgow, Prestwick", city: "Glasgow, Prestwick", country: "United Kingdom" },
  "PIR": { name: "Pierre", city: "Pierre", country: "USA" },
  "PIS": { name: "Biard", city: "Poitiers", country: "France" },
  "PIT": { name: "Pittsburgh International Airport", city: "Pittsburgh International Airport", country: "USA" },
  "PJG": { name: "Panjgur", city: "Panjgur", country: "Pakistan" },
  "PKB": { name: "Pakersburg (WV) /Marietta", city: "Pakersburg (WV) /Marietta", country: "USA" },
  "PKW": { name: "Selibi Phikwe", city: "Selibi Phikwe", country: "Botswana" },
  "PKX": { name: "Beijing Daxing International Airport", city: "Beijing", country: "China" },
  "PLB": { name: "Plattsburgh", city: "Plattsburgh", country: "USA" },
  "PLN": { name: "Pellston", city: "Pellston", country: "USA" },
  "PLO": { name: "Port Lincoln", city: "Port Lincoln", country: "Australia" },
  "PLZ": { name: "Port Elizabeth", city: "Port Elizabeth", country: "South Africa" },
  "PMD": { name: "Palmdale/Lancaster", city: "Palmdale/Lancaster", country: "USA" },
  "PMI": { name: "Palma de Mallorca", city: "Palma de Mallorca", country: "Spain" },
  "PMO": { name: "Punta Raisi", city: "Palermo", country: "Italy" },
  "PMR": { name: "Palmerston North", city: "Palmerston North", country: "New Zealand" },
  "PMV": { name: "Margerita", city: "Margerita", country: "Venezuela" },
  "PMW": { name: "Palmas", city: "Palmas", country: "Brazil" },
  "PNH": { name: "Pochentong", city: "Phnom Penh", country: "Cambodia" },
  "PNI": { name: "Pohnpei", city: "Pohnpei", country: "Micronesia" },
  "PNL": { name: "Pantelleria", city: "Pantelleria", country: "Italy" },
  "PNQ": { name: "Pune", city: "Pune", country: "India, Maharashtra" },
  "PNR": { name: "Pointe Noire", city: "Pointe Noire", country: "Congo (ROC)" },
  "PNS": { name: "Pensacola", city: "Pensacola", country: "USA" },
  "POA": { name: "Salgado Filho International Airport", city: "Porto Alegre", country: "Brazil" },
  "POG": { name: "Port Gentil", city: "Port Gentil", country: "Gabon" },
  "POM": { name: "Jackson Field", city: "Port Moresby", country: "Papua New Guinea" },
  "POP": { name: "Puerto Plata", city: "Puerto Plata", country: "Dominican Republic" },
  "POR": { name: "Pori", city: "Pori", country: "Finland" },
  "POS": { name: "Piarco International", city: "Port of Spain", country: "Trinidad and Tobago" },
  "POU": { name: "Poughkeepsie", city: "Poughkeepsie", country: "USA" },
  "POZ": { name: "Poznan, Lawica", city: "Poznan, Lawica", country: "Poland" },
  "PPG": { name: "Pago Pago", city: "Pago Pago", country: "American Samoa" },
  "PPP": { name: "Prosperpine", city: "Prosperpine", country: "Australia" },
  "PPT": { name: "Faa'a International Airport", city: "Papeete", country: "French Polynesia" },
  "PQI": { name: "Presque Island", city: "Presque Island", country: "USA" },
  "PQQ": { name: "Port Macquarie", city: "Port Macquarie", country: "Australia" },
  "PRG": { name: "Václav Havel Airport Prague", city: "Prague", country: "Czech Republic" },
  "PRN": { name: "Pristina", city: "Pristina", country: "Serbia" },
  "PRY": { name: "Wonderboom Apt.", city: "Pretoria", country: "South Africa" },
  "PSA": { name: "Galileo Galilei", city: "Pisa", country: "Italy" },
  "PSC": { name: "Pasco", city: "Pasco", country: "USA" },
  "PSD": { name: "Port Said", city: "Port Said", country: "Egypt" },
  "PSE": { name: "Ponce", city: "Ponce", country: "Puerto Rico" },
  "PSG": { name: "Petersburg", city: "Petersburg", country: "USA" },
  "PSI": { name: "Pasni", city: "Pasni", country: "Pakistan" },
  "PSP": { name: "Palm Springs", city: "Palm Springs", country: "USA" },
  "PSR": { name: "Pescara", city: "Pescara", country: "Italy" },
  "PTG": { name: "Pietersburg", city: "Pietersburg", country: "South Africa" },
  "PTJ": { name: "Portland", city: "Portland", country: "Australia" },
  "PTP": { name: "Pointe a Pitre", city: "Pointe a Pitre", country: "Guadeloupe" },
  "PTY": { name: "Tocumen International Airport", city: "Panama City", country: "Panama" },
  "PUB": { name: "Pueblo", city: "Pueblo", country: "USA" },
  "PUF": { name: "Pau", city: "Pau", country: "France" },
  "PUG": { name: "Port Augusta", city: "Port Augusta", country: "Australia" },
  "PUJ": { name: "Punta Cana International", city: "Punta Cana", country: "Dominican Republic" },
  "PUQ": { name: "Presidente Carlos Ibáñez del Campo", city: "Punta Arenas", country: "Chile" },
  "PUS": { name: "Gimhae International Airport", city: "Pu San", country: "South Korea" },
  "PUW": { name: "Pullman", city: "Pullman", country: "USA" },
  "PUY": { name: "Pula", city: "Pula", country: "Croatia (Hrvatska)" },
  "PVD": { name: "Providence", city: "Providence", country: "USA" },
  "PVG": { name: "Pudong International Airport", city: "Shanghai", country: "China" },
  "PVH": { name: "Porto Velho", city: "Porto Velho", country: "Brazil" },
  "PVK": { name: "Preveza/Lefkas", city: "Preveza/Lefkas", country: "Greece" },
  "PVR": { name: "Puerto Vallarta", city: "Puerto Vallarta", country: "Mexico" },
  "PWM": { name: "Portland", city: "Portland", country: "USA" },
  "PXM": { name: "Puerto Escondido", city: "Puerto Escondido", country: "Mexico" },
  "PXO": { name: "Porto Santo", city: "Porto Santo", country: "Portugal" },
  "PYB": { name: "Jeypore Airport", city: "Jeypore", country: "India" },
  "PYX": { name: "Pattaya", city: "Pattaya", country: "Thailand" },
  "PZB": { name: "Pietermaritzburg", city: "Pietermaritzburg", country: "South Africa" },
  "PZH": { name: "Zhob", city: "Zhob", country: "Pakistan" },
  "PZO": { name: "Puerto Ordaz", city: "Puerto Ordaz", country: "Venezuela" },
  "QCB": { name: "Chiba City", city: "Chiba City", country: "Japan" },
  "QGF": { name: "Montenegro", city: "Montenegro", country: "Brazil" },
  "QLI": { name: "Limassol", city: "Limassol", country: "Cyprus" },
  "QML": { name: "Mirpur", city: "Mirpur", country: "Pakistan" },
  "QNB": { name: "Anand", city: "Anand", country: "India" },
  "QND": { name: "Novi Sad", city: "Novi Sad", country: "Serbia" },
  "QPG": { name: "Paya Lebar", city: "Singapore", country: "Singapore" },
  "QUF": { name: "Pirita Harbour", city: "Tallinn", country: "Estonia" },
  "RAI": { name: "Nelson Mandela International Airport", city: "Praia", country: "Cape Verde" },
  "RAJ": { name: "Rajkot", city: "Rajkot", country: "India" },
  "RAK": { name: "Menara Airport", city: "Marrakesh", country: "Morocco" },
  "RAP": { name: "Rapid City", city: "Rapid City", country: "USA" },
  "RAR": { name: "Rarotonga", city: "Rarotonga", country: "Cook Island" },
  "RAZ": { name: "Rawala Kot", city: "Rawala Kot", country: "Pakistan" },
  "RBA": { name: "Salé Airport", city: "Rabat", country: "Morocco" },
  "RBR": { name: "Plácido de Castro International Airport", city: "Rio Branco", country: "Brazil" },
  "RCB": { name: "Richards Bay", city: "Richards Bay", country: "South Africa" },
  "RDD": { name: "Redding", city: "Redding", country: "USA" },
  "RDG": { name: "Reading", city: "Reading", country: "USA" },
  "RDM": { name: "Redmond", city: "Redmond", country: "USA" },
  "RDU": { name: "Raleigh/Durham", city: "Raleigh/Durham", country: "USA" },
  "RDZ": { name: "Rodez", city: "Rodez", country: "France" },
  "REC": { name: "Guararapes-Gilberto Freyre International", city: "Recife", country: "Brazil" },
  "REG": { name: "Reggio Calabria", city: "Reggio Calabria", country: "Italy" },
  "REK": { name: "Metropolitan Area", city: "Reykjavik", country: "Iceland" },
  "REU": { name: "Reus", city: "Reus", country: "Spain" },
  "RFD": { name: "Rockford", city: "Rockford", country: "USA" },
  "RFP": { name: "Raiatea", city: "Raiatea", country: "French Polynesia" },
  "RGI": { name: "Rangiroa", city: "Rangiroa", country: "French Polynesia" },
  "RGN": { name: "Yangon International Airport", city: "Yangon", country: "Myanmar" },
  "RHI": { name: "Rhinelander", city: "Rhinelander", country: "USA" },
  "RHO": { name: "Rhodos", city: "Rhodos", country: "Greece" },
  "RIC": { name: "Richmond", city: "Richmond", country: "USA" },
  "RIO": { name: "Rio de Janeiro", city: "Rio de Janeiro", country: "Brazil" },
  "RIX": { name: "Riga International Airport", city: "Riga", country: "Latvia" },
  "RJK": { name: "Rijeka", city: "Rijeka", country: "Croatia (Hrvatska)" },
  "RKD": { name: "Rockland", city: "Rockland", country: "USA" },
  "RKS": { name: "Rock Springs", city: "Rock Springs", country: "USA" },
  "RKT": { name: "Ras al Khaymah", city: "Ras al Khaymah", country: "United Arab Emirates" },
  "RLT": { name: "Arlit", city: "Arlit", country: "Niger" },
  "RMF": { name: "Marsa Alam", city: "Marsa Alam", country: "Egypt" },
  "RMI": { name: "Rimini", city: "Rimini", country: "Italy" },
  "RNB": { name: "Ronneby", city: "Ronneby", country: "Sweden" },
  "RNE": { name: "Roanne", city: "Roanne", country: "France" },
  "RNN": { name: "Roenne", city: "Roenne", country: "Denmark" },
  "RNO": { name: "Reno", city: "Reno", country: "USA" },
  "RNS": { name: "Rennes", city: "Rennes", country: "France" },
  "ROA": { name: "Roanoke", city: "Roanoke", country: "USA" },
  "ROB": { name: "Roberts International", city: "Monrovia", country: "Liberia" },
  "ROC": { name: "Rochester", city: "Rochester", country: "USA" },
  "ROK": { name: "Rockhampton", city: "Rockhampton", country: "Australia" },
  "ROM": { name: "Rome", city: "Rome", country: "Italy" },
  "ROS": { name: "Rosario", city: "Rosario", country: "Argentina" },
  "ROT": { name: "Rotorua", city: "Rotorua", country: "New Zealand" },
  "ROU": { name: "Ruse", city: "Ruse", country: "Bulgaria" },
  "ROV": { name: "Platov International Airport", city: "Rostov-on-Don", country: "Russia" },
  "RRG": { name: "Rodrigues Island", city: "Rodrigues Island", country: "Mauritius" },
  "RSA": { name: "Santa Rosa", city: "Santa Rosa", country: "Argentina" },
  "RSD": { name: "Rock Sound", city: "Rock Sound", country: "Bahamas" },
  "RST": { name: "Rochester", city: "Rochester", country: "USA" },
  "RSW": { name: "Fort Myers, Southwest Florida Reg", city: "Fort Myers, Southwest Florida Reg", country: "USA" },
  "RTB": { name: "Roatan", city: "Roatan", country: "Honduras" },
  "RTM": { name: "Rotterdam", city: "Rotterdam", country: "Netherlands" },
  "RUH": { name: "King Khalid International Airport", city: "Riyadh", country: "Saudi Arabia" },
  "RUN": { name: "Roland Garros Airport", city: "Saint Denis", country: "Reunion" },
  "RVI": { name: "Rostov-on-Don Airport", city: "Rostov-on-Don", country: "Russia" },
  "RVN": { name: "Rovaniemi", city: "Rovaniemi", country: "Finland" },
  "RWI": { name: "Wilson (NC)", city: "Rocky Mount", country: "USA" },
  "RWP": { name: "Rawalpindi", city: "Rawalpindi", country: "Pakistan" },
  "RYK": { name: "Shaikh Zayed International Airport", city: "Rahim Yar Khan", country: "Pakistan" },
  "SAH": { name: "Sana'a International", city: "Sanaa", country: "Yemen" },
  "SAL": { name: "San Salvador", city: "San Salvador", country: "El Salvador" },
  "SAN": { name: "Lindberg Field International (CA)", city: "San Diego", country: "USA" },
  "SAO": { name: "Sao Paulo", city: "Sao Paulo", country: "Brazil" },
  "SAP": { name: "San Pedro Sula", city: "San Pedro Sula", country: "Honduras" },
  "SAT": { name: "San Antonio", city: "San Antonio", country: "USA" },
  "SAV": { name: "Savannah", city: "Savannah", country: "USA" },
  "SAW": { name: "Sabiha Gökçen International Airport", city: "Istanbul", country: "Turkey" },
  "SAY": { name: "Salisbury", city: "Salisbury", country: "Zimbabwe" },
  "SBA": { name: "Santa Barbara", city: "Santa Barbara", country: "USA" },
  "SBK": { name: "Saint Brieuc", city: "Saint Brieuc", country: "France" },
  "SBN": { name: "South Bend", city: "South Bend", country: "USA" },
  "SBP": { name: "San Luis Obisco", city: "San Luis Obisco", country: "USA" },
  "SBU": { name: "Springbok", city: "Springbok", country: "South Africa" },
  "SBW": { name: "Sibu", city: "Sibu", country: "Malaysia" },
  "SBY": { name: "Salisbury", city: "Salisbury", country: "USA" },
  "SCC": { name: "Prudhoe Bay", city: "Prudhoe Bay", country: "USA" },
  "SCE": { name: "State College/Belefonte", city: "State College/Belefonte", country: "USA" },
  "SCF": { name: "Scottsdale", city: "Scottsdale", country: "USA" },
  "SCK": { name: "Stockton", city: "Stockton", country: "USA" },
  "SCL": { name: "Arturo Merino Benítez International", city: "Santiago", country: "Chile" },
  "SCN": { name: "Saarbruecken", city: "Saarbruecken", country: "Germany" },
  "SCQ": { name: "Santiago de Compostela", city: "Santiago de Compostela", country: "Spain" },
  "SCU": { name: "Antonio Maceo Airport", city: "Santiago", country: "Cuba" },
  "SDF": { name: "Louisville", city: "Louisville", country: "USA" },
  "SDH": { name: "Santa Rosa, Copan", city: "Santa Rosa, Copan", country: "Honduras" },
  "SDJ": { name: "Sendai", city: "Sendai", country: "Japan" },
  "SDL": { name: "Sundsvall", city: "Sundsvall", country: "Sweden" },
  "SDQ": { name: "Santo Domingo", city: "Santo Domingo", country: "Dominican Republic" },
  "SDR": { name: "Santander", city: "Santander", country: "Spain" },
  "SDS": { name: "Sado Shima", city: "Sado Shima", country: "Japan" },
  "SDT": { name: "Saidu Sharif", city: "Saidu Sharif", country: "Pakistan" },
  "SDU": { name: "Santos Dumont", city: "Rio de Janeiro", country: "Brazil" },
  "SDY": { name: "Sidney", city: "Sidney", country: "USA" },
  "SEA": { name: "Seattle–Tacoma International", city: "Seattle", country: "USA" },
  "SEB": { name: "Sehba", city: "Sehba", country: "Libya" },
  "SEL": { name: "Kimpo", city: "Seoul", country: "South Korea" },
  "SEN": { name: "Southend", city: "Southend", country: "United Kingdom" },
  "SEW": { name: "Siwa", city: "Siwa", country: "Egypt" },
  "SEZ": { name: "Seychelles International Airport", city: "Mahe", country: "Seychelles" },
  "SFA": { name: "Sfax", city: "Sfax", country: "Tunisia" },
  "SFG": { name: "St. Martin", city: "St. Martin", country: "St. Martin (Guadeloupe)" },
  "SFJ": { name: "Soendre Stroemfjord", city: "Soendre Stroemfjord", country: "Greenland" },
  "SFO": { name: "San Francisco International", city: "San Francisco", country: "USA" },
  "SGD": { name: "Soenderborg", city: "Soenderborg", country: "Denmark" },
  "SGF": { name: "Springfield", city: "Springfield", country: "USA" },
  "SGN": { name: "Tan Son Nhat International", city: "Ho Chi Minh City", country: "Vietnam" },
  "SGU": { name: "St. George", city: "St. George", country: "USA" },
  "SGY": { name: "Skagway", city: "Skagway", country: "USA" },
  "SHA": { name: "Hongqiao", city: "Shanghai", country: "China" },
  "SHD": { name: "Shenandoah Valley/Stauton", city: "Shenandoah Valley/Stauton", country: "USA" },
  "SHE": { name: "Shenyang", city: "Shenyang", country: "Liaoning, PR China" },
  "SHJ": { name: "Sharjah", city: "Sharjah", country: "United Arab Emirates" },
  "SHR": { name: "Sheridan", city: "Sheridan", country: "USA" },
  "SHV": { name: "Shreveport, La", city: "Shreveport, La", country: "USA" },
  "SID": { name: "Sal", city: "Sal", country: "Cape Verde" },
  "SIN": { name: "Changi Airport", city: "Singapore", country: "Singapore" },
  "SIP": { name: "Simferopol", city: "Simferopol", country: "Ukraine" },
  "SIS": { name: "Sishen", city: "Sishen", country: "South Africa" },
  "SIT": { name: "Sitka", city: "Sitka", country: "USA" },
  "SIX": { name: "Singleton", city: "Singleton", country: "Australia" },
  "SJC": { name: "San Jose", city: "San Jose", country: "USA" },
  "SJD": { name: "San Jose Cabo", city: "San Jose Cabo", country: "Mexico" },
  "SJJ": { name: "Sarajevo", city: "Sarajevo", country: "Bosnia and Herzegovina" },
  "SJO": { name: "Juan Santamaría International Airport", city: "San Jose", country: "Costa Rica" },
  "SJT": { name: "San Angelo", city: "San Angelo", country: "USA" },
  "SJU": { name: "Luis Muñoz Marín International Airport", city: "San Juan", country: "Puerto Rico" },
  "SJY": { name: "Seinaejoki", city: "Seinaejoki", country: "Finland" },
  "SKB": { name: "St. Kitts", city: "St. Kitts", country: "St. Kitts and Nevis" },
  "SKD": { name: "Samarkand International Airport", city: "Samarkand", country: "Uzbekistan" },
  "SKG": { name: "Makedonia Apt.", city: "Thessaloniki", country: "Greece" },
  "SKP": { name: "Skopje", city: "Skopje", country: "Macedonia" },
  "SKS": { name: "Skrydstrup", city: "Skrydstrup", country: "Denmark" },
  "SKV": { name: "Mount Sinai", city: "Santa Katarina", country: "Egypt" },
  "SKX": { name: "Saransk Airport", city: "Saransk", country: "Russia" },
  "SKZ": { name: "Sukkur", city: "Sukkur", country: "Pakistan" },
  "SLA": { name: "Salta, Gen Belgrano", city: "Salta, Gen Belgrano", country: "Argentina" },
  "SLC": { name: "Salt Lake City", city: "Salt Lake City", country: "USA" },
  "SLE": { name: "Salem", city: "Salem", country: "USA" },
  "SLL": { name: "Salalah", city: "Salalah", country: "Oman" },
  "SLP": { name: "San Luis Potosi", city: "San Luis Potosi", country: "Mexico" },
  "SLS": { name: "Silistra", city: "Silistra", country: "Bulgaria" },
  "SLU": { name: "St. Lucia Vigle", city: "St. Lucia Vigle", country: "Saint Lucia" },
  "SLZ": { name: "Marechal Cunha Machado International", city: "Sao Luis", country: "Brazil" },
  "SMA": { name: "Santa Maria", city: "Santa Maria", country: "Portugal" },
  "SMF": { name: "Sacramento", city: "Sacramento", country: "USA" },
  "SMI": { name: "Samos", city: "Samos", country: "Greece" },
  "SMX": { name: "Santa Maria", city: "Santa Maria", country: "USA" },
  "SNA": { name: "John Wayne Airport (CA)", city: "Santa Ana", country: "USA" },
  "SNC": { name: "Salinas", city: "Salinas", country: "Ecuador" },
  "SNN": { name: "Shannon", city: "Shannon", country: "Ireland" },
  "SNS": { name: "Salinas", city: "Salinas", country: "USA" },
  "SOF": { name: "Vrazhdebna", city: "Sofia", country: "Bulgaria" },
  "SOG": { name: "Sogndal", city: "Sogndal", country: "Norway" },
  "SOI": { name: "South Molle Island", city: "South Molle Island", country: "Australia" },
  "SON": { name: "Santo", city: "Santo", country: "Vanuatu" },
  "SOT": { name: "Sodankylae", city: "Sodankylae", country: "Finland" },
  "SOU": { name: "Eastleigh", city: "Southampton", country: "United Kingdom" },
  "SPC": { name: "Santa Cruz de la Palma", city: "Santa Cruz de la Palma", country: "Spain" },
  "SPI": { name: "Springfield", city: "Springfield", country: "USA" },
  "SPK": { name: "Sapporo", city: "Sapporo", country: "Hokkaido, Japan" },
  "SPN": { name: "Saipan", city: "Saipan", country: "Northern Mariana Islands" },
  "SPS": { name: "Wichita Falls", city: "Wichita Falls", country: "USA" },
  "SPU": { name: "Split", city: "Split", country: "Croatia (Hrvatska)" },
  "SPY": { name: "San Pedro", city: "San Pedro", country: "Cote d'Ivoire" },
  "SRA": { name: "Santa Rosa", city: "Santa Rosa", country: "Brazil" },
  "SRB": { name: "Santa Rosa", city: "Santa Rosa", country: "Bolivia" },
  "SRL": { name: "Santa Rosalia", city: "Santa Rosalia", country: "Mexico" },
  "SRQ": { name: "Sarasota/Bradenton", city: "Sarasota/Bradenton", country: "USA" },
  "SRZ": { name: "Santa Cruz de la Sierra", city: "Santa Cruz de la Sierra", country: "Bolivia" },
  "SSA": { name: "Salvador International Airport", city: "Salvador", country: "Brazil" },
  "SSG": { name: "Malabo International Airport", city: "Malabo", country: "Equatorial Guinea" },
  "SSH": { name: "Sharm El Sheikh", city: "Sharm El Sheikh", country: "Egypt" },
  "SSL": { name: "Santa Rosalia", city: "Santa Rosalia", country: "Colombia" },
  "STL": { name: "St. Louis (MO) Lambert–St. Louis International Airport", city: "St. Louis (MO) Lambert–St. Louis International Airport", country: "USA" },
  "STN": { name: "Stansted Airport", city: "London", country: "United Kingdom" },
  "STO": { name: "Stockholm Metropolitan Area", city: "Stockholm Metropolitan Area", country: "Sweden" },
  "STR": { name: "Echterdingen", city: "Stuttgart", country: "Germany" },
  "STS": { name: "Santa Rosa", city: "Santa Rosa", country: "USA" },
  "STT": { name: "St. Thomas", city: "St. Thomas", country: "Virgin Islands (U.S.)" },
  "STV": { name: "Surat", city: "Surat", country: "India" },
  "STX": { name: "St. Croix", city: "St. Croix", country: "Virgin Islands (U.S.)" },
  "SUB": { name: "Juanda", city: "Surabaya", country: "Indonesia" },
  "SUF": { name: "Lamezia Terme", city: "Lamezia Terme", country: "Italy" },
  "SUL": { name: "Sui", city: "Sui", country: "Pakistan" },
  "SUN": { name: "Sun Valley", city: "Sun Valley", country: "USA" },
  "SUV": { name: "Nausori Airport (Luvuluvu)", city: "Suva", country: "Fiji" },
  "SUX": { name: "Sioux City IA", city: "Sioux City IA", country: "USA" },
  "SVD": { name: "St. Vincent", city: "St. Vincent", country: "Saint Vincent and the Grenadines" },
  "SVG": { name: "Stavanger", city: "Stavanger", country: "Norway" },
  "SVL": { name: "Savonlinna", city: "Savonlinna", country: "Finland" },
  "SVO": { name: "Sheremetyevo Alexander S. Pushkin International", city: "Moscow", country: "Russia" },
  "SVQ": { name: "Sevilla", city: "Sevilla", country: "Spain" },
  "SVX": { name: "Koltsovo Airport", city: "Yekaterinburg", country: "Russia" },
  "SWF": { name: "Newburgh", city: "Newburgh", country: "USA" },
  "SWP": { name: "Swakopmund", city: "Swakopmund", country: "Namibia" },
  "SXB": { name: "Strasbourg Airport", city: "Strasbourg", country: "France" },
  "SXF": { name: "Berlin, Schoenefeld,", city: "Berlin, Schoenefeld,", country: "Germany" },
  "SXL": { name: "Sligo", city: "Sligo", country: "Ireland" },
  "SXM": { name: "St. Marteen", city: "St. Marteen", country: "Netherlands Antilles" },
  "SXR": { name: "Srinagar", city: "Srinagar", country: "India" },
  "SYD": { name: "Kingsford Smith Airport", city: "Sydney", country: "Australia" },
  "SYR": { name: "Syracuse", city: "Syracuse", country: "USA" },
  "SYY": { name: "Stornway", city: "Stornway", country: "United Kingdom" },
  "SZB": { name: "Sultan Abdul Aziz Shah", city: "Kuala Lumpur", country: "Malaysia" },
  "SZD": { name: "Sheffield, City Airport", city: "Sheffield, City Airport", country: "United Kingdom" },
  "SZF": { name: "Samsun", city: "Samsun", country: "Turkey" },
  "SZG": { name: "W.A. Mozart", city: "Salzburg", country: "Austria" },
  "SZK": { name: "Skukuza", city: "Skukuza", country: "South Africa" },
  "SZX": { name: "Shenzhen Bao'an International", city: "Shenzhen", country: "Guangdong, PR China" },
  "SZZ": { name: "Stettin", city: "Stettin", country: "Poland" },
  "TAB": { name: "Tobago", city: "Tobago", country: "Trinidad and Tobago" },
  "TAK": { name: "Takamatsu", city: "Takamatsu", country: "Japan" },
  "TAM": { name: "Gen. F. Javier Mina", city: "Tampico", country: "Mexico" },
  "TAO": { name: "Qingdao", city: "Qingdao", country: "Shandong, PR China" },
  "TAS": { name: "Islam Karimov Tashkent International", city: "Tashkent", country: "Uzbekistan" },
  "TAY": { name: "Sung Shan", city: "Taipei", country: "Taiwan" },
  "TBS": { name: "Tbilisi International Airport", city: "Tbilisi", country: "Georgia" },
  "TBU": { name: "Fua'Amotu International", city: "Nuku'alofa", country: "Tonga" },
  "TCA": { name: "Tennant Creek", city: "Tennant Creek", country: "Australia" },
  "TCB": { name: "Treasure Cay", city: "Treasure Cay", country: "Bahamas" },
  "TCI": { name: "Tenerife", city: "Tenerife", country: "Spain" },
  "TCL": { name: "Tuscaloosa", city: "Tuscaloosa", country: "USA" },
  "TCU": { name: "Thaba'Nchu", city: "Thaba'Nchu", country: "South Africa" },
  "TED": { name: "Thisted", city: "Thisted", country: "Denmark" },
  "TEM": { name: "Temora", city: "Temora", country: "Australia" },
  "TEQ": { name: "Corlu", city: "Tekirdag", country: "Turkey" },
  "TER": { name: "Terceira", city: "Terceira", country: "Portugal" },
  "TEU": { name: "Te Anau", city: "Te Anau", country: "New Zealand" },
  "TEX": { name: "Telluride", city: "Telluride", country: "USA" },
  "TFN": { name: "Norte Los Rodeos", city: "Tenerife", country: "Spain" },
  "TFS": { name: "Sur Reina Sofia", city: "Tenerife", country: "Spain" },
  "TFU": { name: "Chengdu Tianfu International Airport", city: "Chengdu", country: "China" },
  "TGD": { name: "Podgorica", city: "Podgorica", country: "Montenegro" },
  "TGU": { name: "Tegucigalpa", city: "Tegucigalpa", country: "Honduras" },
  "TGV": { name: "Targovishte", city: "Targovishte", country: "Bulgaria" },
  "TGZ": { name: "Tuxtla Gutierrez", city: "Tuxtla Gutierrez", country: "Mexico" },
  "THE": { name: "Teresina", city: "Teresina", country: "Brazil" },
  "THF": { name: "Berlin, Tempelhof", city: "Berlin, Tempelhof", country: "Germany" },
  "THR": { name: "Mehrabad", city: "Tehran", country: "Iran" },
  "TIA": { name: "Rinas", city: "Tirana", country: "Albania" },
  "TIF": { name: "Taif", city: "Taif", country: "Saudi Arabia" },
  "TIJ": { name: "Rodriguez", city: "Tijuana", country: "Mexico" },
  "TIP": { name: "Tripoli International", city: "Tripoli", country: "Libya" },
  "TIS": { name: "Thursday Island", city: "Thursday Island", country: "Australia" },
  "TIV": { name: "Tivat", city: "Tivat", country: "Montenegro" },
  "TKA": { name: "Talkeetna", city: "Talkeetna", country: "USA" },
  "TKS": { name: "Tokushima", city: "Tokushima", country: "Japan" },
  "TKU": { name: "Turku", city: "Turku", country: "Finland" },
  "TLH": { name: "Tallahassee", city: "Tallahassee", country: "USA" },
  "TLL": { name: "Ulemiste", city: "Tallinn", country: "Estonia" },
  "TLS": { name: "Blagnac Airport", city: "Toulouse", country: "France" },
  "TLV": { name: "Ben Gurion Airport", city: "Tel Aviv", country: "Israel" },
  "TMP": { name: "Tampere", city: "Tampere", country: "Finland" },
  "TMS": { name: "Sao Tome", city: "Sao Tome", country: "Sao Tome & Principe" },
  "TMW": { name: "Tamworth", city: "Tamworth", country: "Australia" },
  "TMZ": { name: "Termez", city: "Termez", country: "Uzbekistan" },
  "TNA": { name: "Jinan", city: "Jinan", country: "Shandong, PR China" },
  "TNG": { name: "Boukhalef", city: "Tangier", country: "Morocco" },
  "TNR": { name: "Ivato International Airport", city: "Antananarivo", country: "Madagascar" },
  "TOD": { name: "Tioman", city: "Tioman", country: "Indonesia" },
  "TOL": { name: "Toledo", city: "Toledo", country: "USA" },
  "TOS": { name: "Tromsoe", city: "Tromsoe", country: "Norway" },
  "TOU": { name: "Touho", city: "Touho", country: "New Caledonia" },
  "TOV": { name: "Tortola", city: "Tortola", country: "British Virgin Islands" },
  "TOY": { name: "Toyama", city: "Toyama", country: "Japan" },
  "TPA": { name: "International (FL)", city: "Tampa", country: "USA" },
  "TPE": { name: "Taoyuan International Airport", city: "Taipei", country: "Taiwan" },
  "TPR": { name: "Tom Price", city: "Tom Price", country: "Australia" },
  "TPS": { name: "Trapani", city: "Trapani", country: "Italy" },
  "TRD": { name: "Trondheim", city: "Trondheim", country: "Norway" },
  "TRF": { name: "Sandefjord", city: "Oslo", country: "Norway" },
  "TRI": { name: "Tri-Cities Regional (TN) /VA", city: "Tri-Cities Regional (TN) /VA", country: "USA" },
  "TRN": { name: "Turin", city: "Turin", country: "Italy" },
  "TRO": { name: "Taree", city: "Taree", country: "Australia" },
  "TRS": { name: "Trieste", city: "Trieste", country: "Italy" },
  "TRV": { name: "Thiruvananthapuram", city: "Thiruvananthapuram", country: "India" },
  "TRZ": { name: "Tiruchirapally", city: "Tiruchirapally", country: "India" },
  "TSB": { name: "Tsumeb", city: "Tsumeb", country: "Namibia" },
  "TSF": { name: "Treviso", city: "Treviso", country: "Italy" },
  "TSN": { name: "Tianjin", city: "Tianjin", country: "China" },
  "TSV": { name: "Townsville", city: "Townsville", country: "Australia" },
  "TTN": { name: "Trenton/Princeton", city: "Trenton/Princeton", country: "USA" },
  "TUK": { name: "Turbat", city: "Turbat", country: "Pakistan" },
  "TUL": { name: "Tulsa", city: "Tulsa", country: "USA" },
  "TUN": { name: "Tunis–Carthage International Airport", city: "Tunis", country: "Tunisia" },
  "TUP": { name: "Tulepo", city: "Tulepo", country: "USA" },
  "TUS": { name: "Tucson", city: "Tucson", country: "USA" },
  "TUU": { name: "Tabuk", city: "Tabuk", country: "Saudi Arabia" },
  "TVC": { name: "Traverse City", city: "Traverse City", country: "USA" },
  "TVF": { name: "Thief River Falls", city: "Thief River Falls", country: "USA" },
  "TVL": { name: "Lake Tahoe", city: "Lake Tahoe", country: "USA" },
  "TWB": { name: "Toowoomba", city: "Toowoomba", country: "Australia" },
  "TWF": { name: "Twin Falls", city: "Twin Falls", country: "USA" },
  "TWU": { name: "Tawau", city: "Tawau", country: "Malaysia" },
  "TXK": { name: "Texarkana", city: "Texarkana", country: "USA" },
  "TXL": { name: "Berlin, Tegel", city: "Berlin, Tegel", country: "Germany" },
  "TYN": { name: "Taiyuan", city: "Taiyuan", country: "Shanxi, PR China" },
  "TYO": { name: "Tokyo", city: "Tokyo", country: "Japan" },
  "TYR": { name: "Tyler", city: "Tyler", country: "USA" },
  "TYS": { name: "Knoxville", city: "Knoxville", country: "USA" },
  "TZX": { name: "Trabzon", city: "Trabzon", country: "Turkey" },
  "UAH": { name: "Ua Huka", city: "Ua Huka", country: "French Polynesia" },
  "UAK": { name: "Narsarsuaq", city: "Narsarsuaq", country: "Greenland" },
  "UAP": { name: "Ua Pou", city: "Ua Pou", country: "French Polynesia" },
  "UBA": { name: "Uberaba", city: "Uberaba", country: "Brazil" },
  "UBJ": { name: "Ube", city: "Ube", country: "Japan" },
  "UBP": { name: "Muang Ubon Airport", city: "Ubon Ratchathani", country: "Thailand" },
  "UCA": { name: "Oneida County Airport", city: "Utica", country: "USA" },
  "UCT": { name: "Ukhta", city: "Ukhta", country: "Russia" },
  "UDE": { name: "Volkel Airport", city: "Uden", country: "Netherlands" },
  "UDI": { name: "Eduardo Gomes Airport", city: "Uberlandia", country: "Brazil" },
  "UDJ": { name: "Uzhgorod", city: "Uzhgorod", country: "Ukraine" },
  "UDR": { name: "Dabok Airport", city: "Udaipur", country: "India" },
  "UEE": { name: "Queenstown", city: "Queenstown", country: "Australia" },
  "UET": { name: "Quetta", city: "Quetta", country: "Pakistan" },
  "UFA": { name: "Ufa", city: "Ufa", country: "Russia" },
  "UGC": { name: "Urgench", city: "Urgench", country: "Uzbekistan" },
  "UGO": { name: "Uige", city: "Uige", country: "Angola" },
  "UHE": { name: "Uherske Hradiste", city: "Uherske Hradiste", country: "Czech Republic" },
  "UII": { name: "Utila", city: "Utila", country: "Honduras" },
  "UIN": { name: "Quincy", city: "Quincy", country: "USA" },
  "UIO": { name: "Mariscal Sucre International Airport", city: "Quito", country: "Ecuador" },
  "UIP": { name: "Quimper", city: "Quimper", country: "France" },
  "UIT": { name: "Jaluit Island", city: "Jaluit Island", country: "Marshall Islands" },
  "UKB": { name: "Kobe", city: "Kobe", country: "Japan" },
  "UKI": { name: "Ukiah", city: "Ukiah", country: "USA" },
  "UKY": { name: "Kyoto", city: "Kyoto", country: "Japan" },
  "ULB": { name: "Ulei", city: "Ulei", country: "Vanuatu" },
  "ULD": { name: "Ulundi", city: "Ulundi", country: "South Africa" },
  "ULN": { name: "Buyant Uhaa Airport", city: "Ulaanbaatar", country: "Mongolia" },
  "ULU": { name: "Gulu", city: "Gulu", country: "Uganda" },
  "UMD": { name: "Uummannaq", city: "Uummannaq", country: "Greenland" },
  "UME": { name: "Umea", city: "Umea", country: "Sweden" },
  "UMR": { name: "Woomera", city: "Woomera", country: "Australia" },
  "UNI": { name: "Union Island", city: "Union Island", country: "Saint Vincent and the Grenadines" },
  "UNK": { name: "Unalakleet", city: "Unalakleet", country: "USA" },
  "UNT": { name: "Baltasound Airport", city: "Unst", country: "United Kingdom" },
  "UPG": { name: "Hasanudin Airport", city: "Ujung Pandang", country: "Indonesia" },
  "UPL": { name: "Upala", city: "Upala", country: "Costa Rica" },
  "UPN": { name: "Uruapan", city: "Uruapan", country: "Mexico" },
  "UPP": { name: "Upolu Point", city: "Upolu Point", country: "USA" },
  "URB": { name: "Ernesto Pochler Airport", city: "Urubupunga", country: "Brazil" },
  "URC": { name: "Urumqi", city: "Urumqi", country: "Xinjiang, PR China" },
  "URG": { name: "Ruben Berta Airport", city: "Uruguaiana", country: "Brazil" },
  "URM": { name: "Uriman", city: "Uriman", country: "Venezuela" },
  "URZ": { name: "Uruzgan", city: "Uruzgan", country: "Afghanistan" },
  "USH": { name: "Islas Malvinas Airport", city: "Ushuaia", country: "Argentina" },
  "USN": { name: "Ulsan", city: "Ulsan", country: "South Korea" },
  "UTH": { name: "Udon Thani", city: "Udon Thani", country: "Thailand" },
  "UTN": { name: "Upington", city: "Upington", country: "South Africa" },
  "UTP": { name: "Utapao", city: "Utapao", country: "Thailand" },
  "UTT": { name: "Umtata", city: "Umtata", country: "South Africa" },
  "UUD": { name: "Ulan-Ude", city: "Ulan-Ude", country: "Russia" },
  "UVE": { name: "Oyem", city: "Oyem", country: "Gabon/Loyautte" },
  "UVF": { name: "St. Lucia Hewanorra", city: "St. Lucia Hewanorra", country: "Saint Lucia" },
  "UVL": { name: "Kharga", city: "New Valley", country: "Egypt" },
  "VAA": { name: "Vaasa", city: "Vaasa", country: "Finland" },
  "VAN": { name: "Ferit Melen", city: "Van", country: "Turkey" },
  "VAP": { name: "Valparaiso", city: "Valparaiso", country: "Chile" },
  "VAR": { name: "Varna", city: "Varna", country: "Bulgaria" },
  "VAS": { name: "Sivas", city: "Sivas", country: "Turkey" },
  "VBS": { name: "Verona (Brescia) Montichiari", city: "Verona (Brescia) Montichiari", country: "Italy" },
  "VBY": { name: "Visby", city: "Visby", country: "Sweden" },
  "VCE": { name: "Marco Polo Airport", city: "Venice", country: "Italy" },
  "VCP": { name: "Viracopos", city: "Sao Paulo", country: "Brazil" },
  "VDA": { name: "Elat, Ovula", city: "Elat, Ovula", country: "Israel" },
  "VDE": { name: "Valverde", city: "Valverde", country: "Spain" },
  "VDZ": { name: "Valdez", city: "Valdez", country: "USA" },
  "VEL": { name: "Vernal", city: "Vernal", country: "USA" },
  "VER": { name: "Veracruz", city: "Veracruz", country: "Mexico" },
  "VFA": { name: "Victoria Falls", city: "Victoria Falls", country: "Zimbabwe" },
  "VGA": { name: "Vijayawada International Airport", city: "Vijayawada", country: "India" },
  "VGO": { name: "Vigo", city: "Vigo", country: "Spain" },
  "VID": { name: "Vidin", city: "Vidin", country: "Bulgaria" },
  "VIE": { name: "Vienna International Airport", city: "Vienna", country: "Austria" },
  "VIJ": { name: "Virgin Gorda", city: "Virgin Gorda", country: "Virgin Islands (British)" },
  "VIS": { name: "Visalia", city: "Visalia", country: "USA" },
  "VIT": { name: "Vitoria", city: "Vitoria", country: "Spain" },
  "VIX": { name: "Eurico de Aguiar Salles Airport", city: "Vitoria", country: "Brazil" },
  "VKO": { name: "Vnukovo Andrei Tupolev International", city: "Moscow", country: "Russia" },
  "VLC": { name: "Valencia", city: "Valencia", country: "Spain" },
  "VLD": { name: "Valdosta", city: "Valdosta", country: "USA" },
  "VLI": { name: "Port Vila", city: "Port Vila", country: "Vanuatu" },
  "VLL": { name: "Valladolid", city: "Valladolid", country: "Spain" },
  "VLN": { name: "Valencia", city: "Valencia", country: "Venezuela" },
  "VLU": { name: "Velikiye Luki", city: "Velikiye Luki", country: "Russia" },
  "VNO": { name: "Wilna", city: "Wilna", country: "Lithuania" },
  "VNS": { name: "Varanasi", city: "Varanasi", country: "India" },
  "VPS": { name: "Fort Walton Beach", city: "Fort Walton Beach", country: "USA" },
  "VRA": { name: "Varadero", city: "Varadero", country: "Cuba" },
  "VRB": { name: "Vero Beach/Ft. Pierce", city: "Vero Beach/Ft. Pierce", country: "USA" },
  "VRK": { name: "Varkaus", city: "Varkaus", country: "Finland" },
  "VRN": { name: "Verona", city: "Verona", country: "Italy" },
  "VSA": { name: "Villahermosa", city: "Villahermosa", country: "Mexico" },
  "VST": { name: "Vasteras", city: "Vasteras", country: "Sweden" },
  "VTE": { name: "Wattay", city: "Vientiane", country: "Lao PDR" },
  "VXO": { name: "Vaexjoe", city: "Vaexjoe", country: "Sweden" },
  "VYD": { name: "Vryheid", city: "Vryheid", country: "South Africa" },
  "WAS": { name: "Washington DC", city: "Washington DC", country: "USA" },
  "WAW": { name: "Warsaw Chopin Airport", city: "Warsaw", country: "Poland" },
  "WDH": { name: "Hosea Kutako International", city: "Windhoek", country: "Namibia" },
  "WEI": { name: "Weipa", city: "Weipa", country: "Australia" },
  "WEL": { name: "Welkom", city: "Welkom", country: "South Africa" },
  "WGA": { name: "Wagga", city: "Wagga", country: "Australia" },
  "WHK": { name: "Whakatane", city: "Whakatane", country: "New Zealand" },
  "WHM": { name: "Wickham", city: "Wickham", country: "Australia" },
  "WIC": { name: "Wick", city: "Wick", country: "United Kingdom" },
  "WIE": { name: "Wiesbaden, Air Base", city: "Wiesbaden, Air Base", country: "Germany" },
  "WLB": { name: "Labouchere Bay", city: "Labouchere Bay", country: "USA" },
  "WLG": { name: "Wellington", city: "Wellington", country: "New Zealand" },
  "WLS": { name: "Wallis", city: "Wallis", country: "Wallis and Futuna Islands" },
  "WMB": { name: "Warrnambool", city: "Warrnambool", country: "Australia" },
  "WNS": { name: "Nawab Shah", city: "Nawab Shah", country: "Pakistan" },
  "WOL": { name: "Wollongong", city: "Wollongong", country: "Australia" },
  "WRE": { name: "Whangarei", city: "Whangarei", country: "New Zealand" },
  "WRG": { name: "Wrangell", city: "Wrangell", country: "USA" },
  "WRL": { name: "Worland", city: "Worland", country: "USA" },
  "WUH": { name: "Wuhan", city: "Wuhan", country: "Hubei, PR China" },
  "WUN": { name: "Wiluna", city: "Wiluna", country: "Australia" },
  "WVB": { name: "Walvis Bay", city: "Walvis Bay", country: "South Africa" },
  "WYA": { name: "Whyalla", city: "Whyalla", country: "Australia" },
  "WYN": { name: "Wyndham", city: "Wyndham", country: "Australia" },
  "WYS": { name: "West Yellowstone", city: "West Yellowstone", country: "USA" },
  "XIY": { name: "Xianyang", city: "Xi'an", country: "Shaanxi, PR China" },
  "XLB": { name: "Lac Brochet, MB", city: "Lac Brochet, MB", country: "Canada" },
  "XMH": { name: "Manihi", city: "Manihi", country: "French Polynesia" },
  "XMN": { name: "Xiamen Gaoqi International Airport", city: "Xiamen", country: "China" },
  "XPK": { name: "Pukatawagan", city: "Pukatawagan", country: "Canada" },
  "XRY": { name: "La Parra", city: "Jerez de la Frontera/Cadiz", country: "Spain" },
  "XSI": { name: "South Indian Lake, MB", city: "South Indian Lake, MB", country: "Canada" },
  "XSP": { name: "Seletar", city: "Singapore", country: "Singapore" },
  "YAK": { name: "Yakutat", city: "Yakutat", country: "USA" },
  "YAO": { name: "Yaounde", city: "Yaounde", country: "Cameroon" },
  "YAT": { name: "Attawapiskat, NT", city: "Attawapiskat, NT", country: "Canada" },
  "YBE": { name: "Uranium City", city: "Uranium City", country: "Canada" },
  "YCB": { name: "Cambridge Bay", city: "Cambridge Bay", country: "Canada" },
  "YDF": { name: "Deer Lake/Corner Brook", city: "Deer Lake/Corner Brook", country: "Canada" },
  "YEA": { name: "Edmonton", city: "Edmonton", country: "Canada" },
  "YEG": { name: "Edmonton International Airport", city: "Edmonton", country: "Canada" },
  "YEV": { name: "Inuvik", city: "Inuvik", country: "Canada" },
  "YFA": { name: "Fort Albert", city: "Fort Albert", country: "Canada" },
  "YFB": { name: "Iqaluit", city: "Iqaluit", country: "Canada" },
  "YFC": { name: "Fredericton", city: "Fredericton", country: "Canada" },
  "YFO": { name: "Flin Flon", city: "Flin Flon", country: "Canada" },
  "YGL": { name: "La Grande", city: "La Grande", country: "Canada" },
  "YGW": { name: "Kuujjuarapik", city: "Kuujjuarapik", country: "Canada" },
  "YGX": { name: "Gillam", city: "Gillam", country: "Canada" },
  "YHM": { name: "Hamilton", city: "Hamilton", country: "Canada" },
  "YHR": { name: "Harrington Harbour, PQ", city: "Harrington Harbour, PQ", country: "Canada" },
  "YHZ": { name: "Halifax International", city: "Halifax International", country: "Canada" },
  "YIF": { name: "St. Augustin, PQ", city: "St. Augustin, PQ", country: "Canada" },
  "YIH": { name: "Yichang", city: "Yichang", country: "Hubei, PR China" },
  "YKA": { name: "Kamloops, BC", city: "Kamloops, BC", country: "Canada" },
  "YKM": { name: "Yakima", city: "Yakima", country: "USA" },
  "YKS": { name: "Yakutsk", city: "Yakutsk", country: "Russia" },
  "YLR": { name: "Leaf Rapids", city: "Leaf Rapids", country: "Canada" },
  "YLW": { name: "Kelowna, BC", city: "Kelowna, BC", country: "Canada" },
  "YMM": { name: "Fort McMurray", city: "Fort McMurray", country: "Canada" },
  "YMQ": { name: "Montreal", city: "Montreal", country: "Canada" },
  "YMX": { name: "Mirabel", city: "Montreal", country: "Canada" },
  "YNB": { name: "Yanbu", city: "Yanbu", country: "Saudi Arabia" },
  "YOK": { name: "Yokohama", city: "Yokohama", country: "Japan" },
  "YOP": { name: "Rainbow Lake, AB", city: "Rainbow Lake, AB", country: "Canada" },
  "YOW": { name: "Ottawa Macdonald–Cartier International", city: "Ottawa", country: "Canada" },
  "YPN": { name: "Port Menier, PQ", city: "Port Menier, PQ", country: "Canada" },
  "YPR": { name: "Prince Rupert/Digby Island", city: "Prince Rupert/Digby Island", country: "Canada" },
  "YQB": { name: "Quebec International", city: "Quebec", country: "Canada" },
  "YQD": { name: "The Pas", city: "The Pas", country: "Canada" },
  "YQG": { name: "Windsor Ontario", city: "Windsor Ontario", country: "Canada" },
  "YQM": { name: "Moncton", city: "Moncton", country: "Canada" },
  "YQR": { name: "Regina", city: "Regina", country: "Canada" },
  "YQT": { name: "Thunder Bay", city: "Thunder Bay", country: "Canada" },
  "YQX": { name: "Gander", city: "Gander", country: "Canada" },
  "YRB": { name: "Resolute Bay", city: "Resolute Bay", country: "Canada" },
  "YSJ": { name: "Saint John", city: "Saint John", country: "Canada" },
  "YSM": { name: "Fort Smith", city: "Fort Smith", country: "Canada" },
  "YSR": { name: "Nanisivik", city: "Nanisivik", country: "Canada" },
  "YTH": { name: "Thompson", city: "Thompson", country: "Canada" },
  "YTO": { name: "Toronto", city: "Toronto", country: "Canada" },
  "YTZ": { name: "Billy Bishop Toronto City Airport", city: "Toronto", country: "Canada" },
  "YUD": { name: "Umiujaq", city: "Umiujaq", country: "Canada" },
  "YUL": { name: "Pierre Elliott Trudeau International Airport", city: "Montreal", country: "Canada" },
  "YUM": { name: "Yuma", city: "Yuma", country: "USA" },
  "YUX": { name: "Hall Beach", city: "Hall Beach", country: "Canada" },
  "YVB": { name: "Bonaventure Airport", city: "Bonaventure, QC", country: "Canada" },
  "YVO": { name: "Val d'Or", city: "Val d'Or", country: "Canada" },
  "YVP": { name: "Kuujjuaq", city: "Kuujjuaq", country: "Canada" },
  "YVQ": { name: "Norman Wells", city: "Norman Wells", country: "Canada" },
  "YVR": { name: "Vancouver International Airport", city: "Vancouver", country: "Canada" },
  "YWG": { name: "Winnipeg International", city: "Winnipeg International", country: "Canada" },
  "YWK": { name: "Wabush", city: "Wabush", country: "Canada" },
  "YXD": { name: "Edmonton, Municipal", city: "Edmonton, Municipal", country: "Canada" },
  "YXE": { name: "Saskatoon", city: "Saskatoon", country: "Canada" },
  "YXJ": { name: "Fort St. John", city: "Fort St. John", country: "Canada" },
  "YXN": { name: "Whale Cove, NT", city: "Whale Cove, NT", country: "Canada" },
  "YXS": { name: "Prince George", city: "Prince George", country: "Canada" },
  "YXT": { name: "Terrace", city: "Terrace", country: "Canada" },
  "YXU": { name: "London", city: "London", country: "Canada" },
  "YXY": { name: "Whitehorse", city: "Whitehorse", country: "Canada" },
  "YYC": { name: "Calgary International Airport", city: "Calgary", country: "Canada" },
  "YYD": { name: "Smithers", city: "Smithers", country: "Canada" },
  "YYJ": { name: "Victoria", city: "Victoria", country: "Canada" },
  "YYQ": { name: "Churchill", city: "Churchill", country: "Canada" },
  "YYR": { name: "Goose Bay", city: "Goose Bay", country: "Canada" },
  "YYT": { name: "St. John's", city: "St. John's", country: "Canada" },
  "YYZ": { name: "Pearson International Airport", city: "Toronto", country: "Canada" },
  "YZF": { name: "Yellowknife", city: "Yellowknife", country: "Canada" },
  "YZP": { name: "Sandspit", city: "Sandspit", country: "Canada" },
  "ZAD": { name: "Zadar", city: "Zadar", country: "Croatia (Hrvatska)" },
  "ZAG": { name: "Zagreb Airport Pleso", city: "Zagreb", country: "Croatia (Hrvatska)" },
  "ZAZ": { name: "Zaragoza", city: "Zaragoza", country: "Spain" },
  "ZBO": { name: "Bowen", city: "Bowen", country: "Australia" },
  "ZCL": { name: "Zacatecas", city: "Zacatecas", country: "Mexico" },
  "ZDJ": { name: "Berne, Railway Service", city: "Berne, Railway Service", country: "Switzerland" },
  "ZIH": { name: "Ixtapa/Zihuatenejo", city: "Ixtapa/Zihuatenejo", country: "Mexico" },
  "ZJK": { name: "Chek Lap Kok", city: "Hong Kong", country: "Hong Kong" },
  "ZKE": { name: "Kaschechawan, PQ", city: "Kaschechawan, PQ", country: "Canada" },
  "ZLO": { name: "Manzanillo", city: "Manzanillo", country: "Mexico" },
  "ZND": { name: "Zinder", city: "Zinder", country: "Niger" },
  "ZNE": { name: "Newman", city: "Newman", country: "Australia" },
  "ZQN": { name: "Queenstown", city: "Queenstown", country: "New Zealand" },
  "ZRH": { name: "Zurich", city: "Zurich", country: "Switzerland" },
  "ZSA": { name: "San Salvador", city: "San Salvador", country: "Bahamas" },
  "ZSS": { name: "Sassandra", city: "Sassandra", country: "Cote d'Ivoire" },
  "ZTH": { name: "Zakynthos", city: "Zakynthos", country: "Greece" },
  "ZTM": { name: "Shamattawa, MB", city: "Shamattawa, MB", country: "Canada" },
  "ZYL": { name: "Sylhet", city: "Sylhet", country: "Bangladesh" },
};

export const getAirportName = (iataCode) => {
  const code = iataCode?.toUpperCase();
  const airport = AIRPORTS[code];
  return airport ? airport.name : code;
};

export const getAirportCity = (iataCode) => {
  const code = iataCode?.toUpperCase();
  const airport = AIRPORTS[code];
  return airport ? airport.city : code;
};

export const getAirportInfo = (iataCode) => {
  const code = iataCode?.toUpperCase();
  return AIRPORTS[code] || { name: code, city: code, country: "Unknown" };
};

export const formatAirport = (iataCode) => {
  const code = iataCode?.toUpperCase();
  const airport = AIRPORTS[code];
  if (airport) return code + " - " + airport.name;
  return code;
};

export const formatAirportShort = (iataCode) => {
  const code = iataCode?.toUpperCase();
  const airport = AIRPORTS[code];
  if (airport) return code + " (" + airport.city + ")";
  return code;
};
